export const sidToForms: {
	[mod: string]: {
		[sid: string]: {
			id: string;
			isLimitedAccess: boolean;
			titleMessageId: string;
		}[];
	};
} = {
	"basic-health": {
		"basic_health|ab0": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|ab0_0": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|ab0_a": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|ab0_ab": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|ab0_avar": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|ab0_b": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|ab0_bvar": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|acei": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|adrenalin_or_noradrenalin": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|allopurinol": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|anamnestic_alcohol_abuse": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"basic_health|antiarrhythmic_agent": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|antibiotic": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|anticoagulant": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|arb": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|arni": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|bbl": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|bmi": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"basic_health|bsa": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"basic_health|comment_for_blood_group": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|current_alcohol_abuse": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"basic_health|current_alcohol_use": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"basic_health|description_of_patient_condition": [
			{
				id: "bh_patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			},
			{
				id: "bh_patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"basic_health|digitalis": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|diuretic": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|dobutamine": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|dopamine": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|ecg_procedure": [
			{
				id: "bh_ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"basic_health|fvs": [
			{
				id: "bh_fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"basic_health|ggt": [
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"basic_health|got": [
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"basic_health|gpt": [
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"basic_health|haemoglobin": [
			{
				id: "bh_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"basic_health|heart_failure_medical_therapy": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|heart_failure_medical_therapy_other_medicine": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|height": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"basic_health|ivabradine": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|lab_bloodcount": [
			{
				id: "bh_fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "bh_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"basic_health|lab_diab": [
			{
				id: "bh_serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"basic_health|lab_hepat": [
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"basic_health|levosimendan": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|mental_health_review": [
			{
				id: "bh_mentalHealthReview",
				isLimitedAccess: false,
				titleMessageId: "form.mental_health_review"
			}
		],
		"basic_health|mra": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|patient_condition": [
			{
				id: "bh_patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"basic_health|patient_condition_report": [
			{
				id: "bh_patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"basic_health|patient_statement_of_consent": [
			{
				id: "bh_patientStatementOfConsent",
				isLimitedAccess: false,
				titleMessageId: "form.patient_statement_of_consent"
			}
		],
		"basic_health|patient_status": [
			{
				id: "bh_patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"basic_health|pde_inhibitor": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|rh": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|rh_negative": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|rh_positive": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"basic_health|serum_glucose": [
			{
				id: "bh_serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"basic_health|signed_statement_of_consent": [
			{
				id: "bh_patientStatementOfConsent",
				isLimitedAccess: false,
				titleMessageId: "form.patient_statement_of_consent"
			}
		],
		"basic_health|smoking": [
			{
				id: "bh_smoking",
				isLimitedAccess: false,
				titleMessageId: "form.smoking"
			}
		],
		"basic_health|social_worker_review": [
			{
				id: "bh_socialWorkerReview",
				isLimitedAccess: false,
				titleMessageId: "form.social_worker_review"
			}
		],
		"basic_health|statin": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|summary_of_alcohol_use": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"basic_health|trombocyta_aggregation_inhibitor": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"basic_health|weight": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|10331-7": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|11524-6": [
			{
				id: "bh_ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"loinc|1742-6": [
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"loinc|1920-8": [
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"loinc|2324-2": [
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"loinc|24325-3": [
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"loinc|29463-7": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|3140-1": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|34530-6": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|39156-5": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|39480-9": [
			{
				id: "bh_serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"loinc|5418-8": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|55429-5": [
			{
				id: "bh_fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "bh_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"loinc|6690-2": [
			{
				id: "bh_fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"loinc|718-7": [
			{
				id: "bh_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"loinc|8302-2": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|883-9": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|112143006": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|128178001": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|15167005": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|15240007": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|185283008": [
			{
				id: "bh_socialWorkerReview",
				isLimitedAccess: false,
				titleMessageId: "form.social_worker_review"
			}
		],
		"snomed|20135006": [
			{
				id: "bh_fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "bh_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "bh_serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"snomed|219006": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|224238005": [
			{
				id: "bh_patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|248326004": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|26958001": [
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"snomed|281789004": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|308118002": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|315053001": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|33747003": [
			{
				id: "bh_serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"snomed|34608000": [
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"snomed|363783003": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|363808001": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|365636006": [
			{
				id: "bh_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|365809007": [
			{
				id: "bh_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"snomed|365981007": [
			{
				id: "bh_smoking",
				isLimitedAccess: false,
				titleMessageId: "form.smoking"
			}
		],
		"snomed|371534008": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|372603003": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372695000": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372733002": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372813008": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372862008": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372913009": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|373254001": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|387135004": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|387145002": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|387521006": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|396550006": [
			{
				id: "bh_fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "bh_gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "bh_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "bh_serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"snomed|401061005": [
			{
				id: "bh_mentalHealthReview",
				isLimitedAccess: false,
				titleMessageId: "form.mental_health_review"
			}
		],
		"snomed|410513005": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|412383006": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|421228002": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|442795003": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|447113005": [
			{
				id: "bh_ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"snomed|45896001": [
			{
				id: "bh_got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"snomed|50373000": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|60621009": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|69480007": [
			{
				id: "bh_ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"snomed|713127001": [
			{
				id: "bh_alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|767002": [
			{
				id: "bh_fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"snomed|771452004": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|777480008": [
			{
				id: "bh_heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"srtr|can_hgt_cm": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"srtr|can_most_recent_wgt_kg7": [
			{
				id: "bh_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		]
	},
	htx: {
		"htx|6mwt": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"htx|BNP": [
			{
				id: "bnp",
				isLimitedAccess: false,
				titleMessageId: "form.bnp"
			}
		],
		"htx|NT-proBNP": [
			{
				id: "ntProBNP",
				isLimitedAccess: false,
				titleMessageId: "form.nt_pro_bnp"
			}
		],
		"htx|TAPSE": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|ab0": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"htx|abdominal_ultrasound_result": [
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			}
		],
		"htx|abi_result": [
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			}
		],
		"htx|able_to_6MWT": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"htx|able_to_spiroergometry": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|acei": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|achieved_max_capacity": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|adrenalin_or_noradrenalin": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|alkaline_phosphatase": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"htx|allopurinol": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|anamnestic_alcohol_abuse": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|antiarrhythmic_agent": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|antibiotic": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|anticoagulant": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|aortic_insufficiency": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|aortic_root_size": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|aortic_valve_gradient": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|arb": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|arni": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|artoa_ascendens_size": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|bbl": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|beta_blocker_during_spiroergometry": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|bilirubin_direct": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"htx|bilirubin_total": [
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"htx|bmi": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"htx|bsa": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"htx|cardiac_index_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|cardiac_output_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|cartois_doppler_result": [
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			}
		],
		"htx|cct_summary": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			}
		],
		"htx|central_venous_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|chest_ct_result": [
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			}
		],
		"htx|chest_x_ray_result": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"htx|ci": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|cmri_summary": [
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			}
		],
		"htx|cmv": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"htx|cmv_igg": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"htx|co": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|colonoscopy_result": [
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			}
		],
		"htx|combined_transplant": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|comment_for_blood_group": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"htx|coombs_direct": [
			{
				id: "coombsDirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_direct"
			}
		],
		"htx|coombs_indirect": [
			{
				id: "coombsIndirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_indirect"
			}
		],
		"htx|coronarography_summary": [
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			}
		],
		"htx|covid_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|cpet_summary": [
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			}
		],
		"htx|creatinine": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"htx|crp": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"htx|current_alcohol_abuse": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|current_alcohol_use": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|cvp": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|dental_screening_result": [
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			}
		],
		"htx|dermatology_result": [
			{
				id: "dermatology",
				isLimitedAccess: false,
				titleMessageId: "form.dermatology"
			}
		],
		"htx|description_of_patient_condition": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			},
			{
				id: "patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"htx|dexa_result": [
			{
				id: "dexa",
				isLimitedAccess: false,
				titleMessageId: "form.dexa"
			}
		],
		"htx|diastolic_blood_pressure": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"htx|diastolic_dysfunction": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|digital_rectal_exam_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"htx|digitalis": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|diuretic": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|dobutamine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|dopamine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|ear_nose_throat": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"htx|ebv_serology": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"htx|ebv_serology_igg": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"htx|ecg_procedure": [
			{
				id: "ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"htx|echocardiography": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|echocardiography_summary": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|edd": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|ejection_fraction": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|estimated_right_ventricular_peak_systolic_pressure": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|flu_shot": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|fvs": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"htx|gfr": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"htx|ggt": [
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"htx|got": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"htx|gpt": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"htx|gynecology_result": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"htx|haemoglobin": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"htx|hav_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|hbc_ab_igg": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbc_ab_igm": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbs_ab": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbs_ag": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbv_status": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbv_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|heart_asist_system_therapy": [
			{
				id: "heartAssistSystemTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_assist_system_therapy"
			}
		],
		"htx|heart_failure_etiology": [
			{
				id: "heartFailureEtiology",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_etiology"
			}
		],
		"htx|heart_failure_medical_therapy": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|heart_failure_medical_therapy_other_medicine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|heart_rate": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"htx|heart_rate_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|height": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"htx|hepa_c_virus_screening": [
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.hcv"
			}
		],
		"htx|hgb_a1_c": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"htx|hiv_screening": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"htx|hospitalizations": [
			{
				id: "hospitalizations",
				isLimitedAccess: false,
				titleMessageId: "form.hospitalizations"
			}
		],
		"htx|hpv_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|hr": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|hsv1_serology": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"htx|hsv1_serology_igg": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"htx|hsv2_serology": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"htx|hsv2_serology_igg": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"htx|hyper_immunised": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|inr": [
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"htx|ivabradine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|karbamid": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"htx|lab_bloodcount": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"htx|lab_diab": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"htx|lab_endocrin": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"htx|lab_hepat": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"htx|lab_inflamm": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"htx|lab_neph": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"htx|ldh": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"htx|left_atrial_diameter1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|left_atrial_diameter2": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|levosimendan": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|mammography_result": [
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			}
		],
		"htx|mcs": [
			{
				id: "heartAssistSystemTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_assist_system_therapy"
			}
		],
		"htx|medical_history_summary": [
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"htx|meningococcus_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|mental_health_review": [
			{
				id: "mentalHealthReview",
				isLimitedAccess: false,
				titleMessageId: "form.mental_health_review"
			}
		],
		"htx|mitral_insufficiency": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|mpap": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|mpcwp": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|mra": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|natrium": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"htx|number_of_thoracotomies": [
			{
				id: "thoracotomies",
				isLimitedAccess: false,
				titleMessageId: "form.thoracotomies"
			}
		],
		"htx|nyha_stage": [
			{
				id: "nyha",
				isLimitedAccess: false,
				titleMessageId: "form.nyha"
			}
		],
		"htx|ophthalmologic_examination_result": [
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			}
		],
		"htx|pacemaker_therapy": [
			{
				id: "pacemakerTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.pacemaker_therapy"
			}
		],
		"htx|papanicolaou": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"htx|papd": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|paps": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|patient_condition": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|patient_condition_report": [
			{
				id: "patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"htx|patient_et_id": [
			{
				id: "coordination",
				isLimitedAccess: false,
				titleMessageId: "form.coordination"
			}
		],
		"htx|patient_statement_of_consent": [
			{
				id: "patientStatementOfConsent",
				isLimitedAccess: false,
				titleMessageId: "form.patient_statement_of_consent"
			}
		],
		"htx|patient_status": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|pde_inhibitor": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|platelet_count": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"htx|pneumococus_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|posterior_wall_thickness": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|potassium": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"htx|pra_cdc": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"htx|pra_luminex": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"htx|prealbumin": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"htx|prostate_specific_antigen_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"htx|proteinuria_result": [
			{
				id: "proteinuria",
				isLimitedAccess: false,
				titleMessageId: "form.proteinuria"
			}
		],
		"htx|psa": [
			{
				id: "psa",
				isLimitedAccess: false,
				titleMessageId: "form.psa"
			}
		],
		"htx|pseudocholinesterase": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"htx|psychiatry_result": [
			{
				id: "psychiatry",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatry"
			}
		],
		"htx|pulmonary_artery_diastolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_artery_mean_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_artery_systolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_artery_wedge_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_valve_ventriculoarterial_gradient_post": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_vascular_resistance_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonology_result": [
			{
				id: "pulmonology",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonology"
			}
		],
		"htx|pvr": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rh": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"htx|right_atrial_diameter1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|right_atrial_diameter2": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|right_heart_catheterization": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|right_ventricular_diastolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|right_ventricular_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|right_ventricular_systolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rrs": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rv_size": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|rvpd": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rvpm": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rvps": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|seen_by_anesthetist": [
			{
				id: "anesthesiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.anesthesiologist_opinion"
			}
		],
		"htx|seen_by_diabetologist": [
			{
				id: "diabetologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.diabetologist_opinion"
			}
		],
		"htx|seen_by_endocrinologist": [
			{
				id: "endocrinologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.endocrinologist_opinion"
			}
		],
		"htx|seen_by_gastroenterologist": [
			{
				id: "gastroenterologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.gastroenterologist_opinion"
			}
		],
		"htx|seen_by_geneticist": [
			{
				id: "geneticistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.geneticist_opinion"
			}
		],
		"htx|seen_by_hematologist": [
			{
				id: "hematologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hematologist_opinion"
			}
		],
		"htx|seen_by_hepatologist": [
			{
				id: "hepatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hepatologist_opinion"
			}
		],
		"htx|seen_by_immunologist": [
			{
				id: "immunologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.immunologist_opinion"
			}
		],
		"htx|seen_by_infectologist": [
			{
				id: "infectologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.infectologist_opinion"
			}
		],
		"htx|seen_by_nephrologist": [
			{
				id: "nephrologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.nephrologist_opinion"
			}
		],
		"htx|seen_by_neurologist": [
			{
				id: "neurologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.neurologist_opinion"
			}
		],
		"htx|seen_by_oncologist": [
			{
				id: "oncologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.oncologist_opinion"
			}
		],
		"htx|seen_by_radiologist": [
			{
				id: "radiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.radiologist_opinion"
			}
		],
		"htx|seen_by_rheumatologist": [
			{
				id: "rheumatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.rheumatologist_opinion"
			}
		],
		"htx|seen_by_vascular_surgeon": [
			{
				id: "vascularSurgeonOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.vascular_surgeon_opinion"
			}
		],
		"htx|septal_wall_thickness": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|serum_albumin": [
			{
				id: "albumin",
				isLimitedAccess: false,
				titleMessageId: "form.albumin"
			}
		],
		"htx|serum_glucose": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"htx|signed_statement_of_consent": [
			{
				id: "patientStatementOfConsent",
				isLimitedAccess: false,
				titleMessageId: "form.patient_statement_of_consent"
			}
		],
		"htx|smoking": [
			{
				id: "smoking",
				isLimitedAccess: false,
				titleMessageId: "form.smoking"
			}
		],
		"htx|social_worker_review": [
			{
				id: "socialWorkerReview",
				isLimitedAccess: false,
				titleMessageId: "form.social_worker_review"
			}
		],
		"htx|spect_summary": [
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"htx|spiro_fields": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|statin": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|stool_blood_result": [
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			}
		],
		"htx|stool_culture_result": [
			{
				id: "stoolculture",
				isLimitedAccess: false,
				titleMessageId: "form.stoolculture"
			}
		],
		"htx|summary_of_alcohol_use": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|summary_of_thoracotomies": [
			{
				id: "thoracotomies",
				isLimitedAccess: false,
				titleMessageId: "form.thoracotomies"
			}
		],
		"htx|summary_report_by_cardiologist": [
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"htx|sv02": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|systolic_blood_pressure": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"htx|systolic_blood_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|t3": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"htx|t4": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"htx|toxoplasma_serology": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"htx|toxoplasma_serology_igg": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"htx|tpg": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|transplant_immun_concilium": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"htx|treponema_pallidum_org_screening_procedure": [
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			}
		],
		"htx|tricuspid_insufficiency": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|trombocyta_aggregation_inhibitor": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|tsh": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"htx|urgency": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|urine_culture_result": [
			{
				id: "urineculture",
				isLimitedAccess: false,
				titleMessageId: "form.urineculture"
			}
		],
		"htx|urine_sediment_result": [
			{
				id: "urinesediment",
				isLimitedAccess: false,
				titleMessageId: "form.urinesediment"
			}
		],
		"htx|urology_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"htx|varicella_serology": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"htx|varicella_serology_igg": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"htx|vasoreactivity_test": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|venous_oxygen_saturation_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|vo2": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|waiting_list_start_date": [
			{
				id: "coordination",
				isLimitedAccess: false,
				titleMessageId: "form.coordination"
			}
		],
		"htx|weight": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|10230-1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|10331-7": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|11154-2": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"loinc|11524-6": [
			{
				id: "ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"loinc|13946-9": [
			{
				id: "coombsDirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_direct"
			},
			{
				id: "coombsIndirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_indirect"
			}
		],
		"loinc|14338-8": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"loinc|14631-6": [
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"loinc|14920-3": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"loinc|14928-6": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"loinc|14937-7": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"loinc|16954-0": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"loinc|1742-6": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"loinc|1751-7": [
			{
				id: "albumin",
				isLimitedAccess: false,
				titleMessageId: "form.albumin"
			}
		],
		"loinc|18066-1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18112-3": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18113-1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18115-6": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18746-8": [
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			}
		],
		"loinc|19162-7": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"loinc|1920-8": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"loinc|1988-5": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"loinc|20464-4": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"loinc|2160-0": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"loinc|22244-8": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"loinc|22322-2": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|22580-5": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"loinc|2324-2": [
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"loinc|24325-3": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"loinc|24362-6": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"loinc|24616-5": [
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			}
		],
		"loinc|24748-6": [
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			}
		],
		"loinc|25020": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"loinc|2532-0": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"loinc|26515-7": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"loinc|2711-0": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|29463-7": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|2947-0": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"loinc|31204-1": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|3140-1": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|32685-0": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|33762-6": [
			{
				id: "bnp",
				isLimitedAccess: false,
				titleMessageId: "form.bnp"
			},
			{
				id: "ntProBNP",
				isLimitedAccess: false,
				titleMessageId: "form.nt_pro_bnp"
			}
		],
		"loinc|33914-3": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"loinc|34530-6": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|34714-6": [
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"loinc|34851-6": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"loinc|36572-6": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"loinc|39156-5": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|39480-9": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"loinc|407367": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"loinc|42148-7": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|43111-4": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"loinc|44137-8": [
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			}
		],
		"loinc|49178-7": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"loinc|50196-5": [
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			}
		],
		"loinc|5195-3": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|53764-7": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"loinc|5418-8": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|55112-7": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			},
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			},
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			},
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			},
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			},
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			},
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"loinc|55429-5": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"loinc|58271-8": [
			{
				id: "pacemakerTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.pacemaker_therapy"
			}
		],
		"loinc|58744-4": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			}
		],
		"loinc|60842-2": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"loinc|60985-9": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|6298-4": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"loinc|64098-7": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"loinc|64663-8": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|6690-2": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"loinc|6768-6": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"loinc|718-7": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"loinc|72056-5": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|72057-3": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|72058-1": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|75919-1": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|76269-0": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"loinc|77194-9": [
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			}
		],
		"loinc|78930-5": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|80737-0": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"loinc|80994-7": [
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			}
		],
		"loinc|82593-5": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|82654-5": [
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"loinc|8302-2": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|8377-4": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8385-7": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8406-1": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8414-5": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8432-7": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8440-0": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8462-4": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"loinc|8480-6": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"loinc|8587-8": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|86910-7": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"loinc|8741-1": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|88020-3": [
			{
				id: "nyha",
				isLimitedAccess: false,
				titleMessageId: "form.nyha"
			}
		],
		"loinc|8828-6": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|883-9": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|8867-4": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"loinc|94141-9": [
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			}
		],
		"snomed|1030791000000100": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|103306004": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"snomed|104305007": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"snomed|104321002": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"snomed|104326007": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|105011006": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"snomed|111287006": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|112143006": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|113075003": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"snomed|1142178009": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|117010004": [
			{
				id: "urineculture",
				isLimitedAccess: false,
				titleMessageId: "form.urineculture"
			}
		],
		"snomed|117028002": [
			{
				id: "stoolculture",
				isLimitedAccess: false,
				titleMessageId: "form.stoolculture"
			}
		],
		"snomed|117739006": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"snomed|118227000": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|118433006": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|128178001": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|129714008": [
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			}
		],
		"snomed|15167005": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|15240007": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|165994006": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			},
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			},
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			},
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			},
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			},
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|166324000": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"snomed|166329005": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"snomed|169069000": [
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			}
		],
		"snomed|170337005": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|170865004": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"snomed|170945005": [
			{
				id: "dermatology",
				isLimitedAccess: false,
				titleMessageId: "form.dermatology"
			},
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			}
		],
		"snomed|171121004": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"snomed|177765008": [
			{
				id: "thoracotomies",
				isLimitedAccess: false,
				titleMessageId: "form.thoracotomies"
			}
		],
		"snomed|185283008": [
			{
				id: "socialWorkerReview",
				isLimitedAccess: false,
				titleMessageId: "form.social_worker_review"
			}
		],
		"snomed|19030005": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"snomed|1951000175101": [
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"snomed|20135006": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			},
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			},
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			},
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			},
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			},
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			},
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			},
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.hcv"
			},
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			},
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			},
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			},
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			},
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			},
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			},
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			},
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			},
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			},
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			},
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			},
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			},
			{
				id: "dermatology",
				isLimitedAccess: false,
				titleMessageId: "form.dermatology"
			},
			{
				id: "dexa",
				isLimitedAccess: false,
				titleMessageId: "form.dexa"
			},
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			},
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			},
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			},
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			},
			{
				id: "psychiatry",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatry"
			},
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			},
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|219006": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|224238005": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|23901000087101": [
			{
				id: "hepatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hepatologist_opinion"
			}
		],
		"snomed|241439007": [
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			}
		],
		"snomed|241547009": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			}
		],
		"snomed|241620005": [
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			}
		],
		"snomed|241686001": [
			{
				id: "dexa",
				isLimitedAccess: false,
				titleMessageId: "form.dexa"
			}
		],
		"snomed|2425002": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"snomed|243806009": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			},
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			},
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			},
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			},
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			},
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			},
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			},
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"snomed|248326004": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|250644007": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"snomed|250768007": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|250769004": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|250770003": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|250908004": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|250929008": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|250964004": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|251086009": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|251088005": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|252478000": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"snomed|26958001": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"snomed|271649006": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|271650006": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|276756009": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|276772001": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|276773006": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|276901002": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|281789004": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|29738008": [
			{
				id: "proteinuria",
				isLimitedAccess: false,
				titleMessageId: "form.proteinuria"
			}
		],
		"snomed|30200007": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"snomed|305634004": [
			{
				id: "anesthesiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.anesthesiologist_opinion"
			}
		],
		"snomed|305635003": [
			{
				id: "oncologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.oncologist_opinion"
			}
		],
		"snomed|305657005": [
			{
				id: "hematologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hematologist_opinion"
			}
		],
		"snomed|305666009": [
			{
				id: "immunologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.immunologist_opinion"
			}
		],
		"snomed|305671002": [
			{
				id: "endocrinologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.endocrinologist_opinion"
			}
		],
		"snomed|305672009": [
			{
				id: "gastroenterologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.gastroenterologist_opinion"
			}
		],
		"snomed|305674005": [
			{
				id: "geneticistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.geneticist_opinion"
			}
		],
		"snomed|305683000": [
			{
				id: "nephrologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.nephrologist_opinion"
			}
		],
		"snomed|305688009": [
			{
				id: "rheumatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.rheumatologist_opinion"
			}
		],
		"snomed|305701006": [
			{
				id: "radiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.radiologist_opinion"
			}
		],
		"snomed|305710003": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"snomed|305729009": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|305730004": [
			{
				id: "vascularSurgeonOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.vascular_surgeon_opinion"
			}
		],
		"snomed|307280005": [
			{
				id: "pacemakerTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.pacemaker_therapy"
			}
		],
		"snomed|308118002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|312468003": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"snomed|312469006": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"snomed|313587003": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|313604004": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"snomed|313954007": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"snomed|315053001": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|315199001": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"snomed|33367005": [
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			}
		],
		"snomed|33747003": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"snomed|34043003": [
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			}
		],
		"snomed|34608000": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"snomed|3545003": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|359986008": [
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"snomed|363783003": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|363808001": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|364075005": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|365636006": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|365809007": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"snomed|365981007": [
			{
				id: "smoking",
				isLimitedAccess: false,
				titleMessageId: "form.smoking"
			}
		],
		"snomed|371534008": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			},
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			},
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			},
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			},
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			},
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			},
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			},
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|372603003": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372695000": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372733002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372813008": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372862008": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372913009": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|373254001": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|386100006": [
			{
				id: "urinesediment",
				isLimitedAccess: false,
				titleMessageId: "form.urinesediment"
			}
		],
		"snomed|387135004": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|387145002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|387521006": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|39031000119103": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|390842003": [
			{
				id: "diabetologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.diabetologist_opinion"
			}
		],
		"snomed|39361000119108": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|394719009": [
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			}
		],
		"snomed|395043005": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"snomed|396550006": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			},
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			},
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"snomed|39748002": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"snomed|399023006": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|399208008": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"snomed|401061005": [
			{
				id: "mentalHealthReview",
				isLimitedAccess: false,
				titleMessageId: "form.mental_health_review"
			}
		],
		"snomed|401221002": [
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			}
		],
		"snomed|40701008": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|408218006": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"snomed|408864009": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|410006001": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|410513005": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|412383006": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|416683003": [
			{
				id: "hospitalizations",
				isLimitedAccess: false,
				titleMessageId: "form.hospitalizations"
			}
		],
		"snomed|421228002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|43396009": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"snomed|43941000119105": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|440614003": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"snomed|442349007": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|442516004": [
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			}
		],
		"snomed|44277000": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"snomed|442795003": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|444562008": [
			{
				id: "pulmonology",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonology"
			}
		],
		"snomed|447113005": [
			{
				id: "ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"snomed|447346005": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"snomed|45036003": [
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			}
		],
		"snomed|45896001": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"snomed|47758006": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|48724000": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|50373000": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|50506008": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|50684000": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"snomed|54247002": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|54555005": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|54993008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|55235003": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"snomed|60234000": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|60621009": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|61167004": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"snomed|61928009": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"snomed|62889000": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|62944002": [
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.hcv"
			}
		],
		"snomed|63476009": [
			{
				id: "psa",
				isLimitedAccess: false,
				titleMessageId: "form.psa"
			}
		],
		"snomed|64253000": [
			{
				id: "heartAssistSystemTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_assist_system_therapy"
			}
		],
		"snomed|65677008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|65911000": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|69480007": [
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"snomed|709549003": [
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"snomed|711047004": [
			{
				id: "neurologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.neurologist_opinion"
			}
		],
		"snomed|712756001": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|713127001": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|71420008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|716579001": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|723279008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|72904005": [
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			}
		],
		"snomed|73701000119109": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|73761001": [
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			}
		],
		"snomed|74427007": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"snomed|74732009": [
			{
				id: "psychiatry",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatry"
			}
		],
		"snomed|762994006": [
			{
				id: "nyha",
				isLimitedAccess: false,
				titleMessageId: "form.nyha"
			}
		],
		"snomed|767002": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"snomed|76899008": [
			{
				id: "infectologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.infectologist_opinion"
			}
		],
		"snomed|771452004": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|77465005": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|777480008": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|7928001": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"snomed|80274001": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"snomed|8128003": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|82799009": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|88810008": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"snomed|89780004": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|99501000119107": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"srtr|can_hgt_cm": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"srtr|can_most_recent_wgt_kg7": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		]
	},
	htx_nm: {
		"htx|6mwt": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"htx|BNP": [
			{
				id: "bnp",
				isLimitedAccess: false,
				titleMessageId: "form.bnp"
			}
		],
		"htx|NT-proBNP": [
			{
				id: "ntProBNP",
				isLimitedAccess: false,
				titleMessageId: "form.nt_pro_bnp"
			}
		],
		"htx|TAPSE": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|ab0": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"htx|abdominal_ultrasound_result": [
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			}
		],
		"htx|abi_result": [
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			}
		],
		"htx|able_to_6MWT": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"htx|able_to_spiroergometry": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|acei": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|achieved_max_capacity": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|adrenalin_or_noradrenalin": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|alkaline_phosphatase": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"htx|allopurinol": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|anamnestic_alcohol_abuse": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|antiarrhythmic_agent": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|antibiotic": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|anticoagulant": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|aortic_insufficiency": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|aortic_root_size": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|aortic_valve_gradient": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|arb": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|arni": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|artoa_ascendens_size": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|bbl": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|beta_blocker_during_spiroergometry": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|bilirubin_direct": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"htx|bilirubin_total": [
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"htx|bmi": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"htx|bsa": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"htx|cardiac_index_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|cardiac_output_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|cartois_doppler_result": [
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			}
		],
		"htx|cct_summary": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			}
		],
		"htx|central_venous_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|chest_ct_result": [
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			}
		],
		"htx|chest_x_ray_result": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"htx|ci": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|cmri_summary": [
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			}
		],
		"htx|cmv": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"htx|cmv_igg": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"htx|co": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|colonoscopy_result": [
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			}
		],
		"htx|combined_transplant": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|comment_for_blood_group": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"htx|coombs_direct": [
			{
				id: "coombsDirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_direct"
			}
		],
		"htx|coombs_indirect": [
			{
				id: "coombsIndirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_indirect"
			}
		],
		"htx|coronarography_summary": [
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			}
		],
		"htx|covid_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|cpet_summary": [
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			}
		],
		"htx|creatinine": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"htx|crp": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"htx|current_alcohol_abuse": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|current_alcohol_use": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|cvp": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|dental_screening_result": [
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			}
		],
		"htx|dermatology_result": [
			{
				id: "dermatology",
				isLimitedAccess: false,
				titleMessageId: "form.dermatology"
			}
		],
		"htx|description_of_patient_condition": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			},
			{
				id: "patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"htx|dexa_result": [
			{
				id: "dexa",
				isLimitedAccess: false,
				titleMessageId: "form.dexa"
			}
		],
		"htx|diastolic_blood_pressure": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"htx|diastolic_dysfunction": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|digital_rectal_exam_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"htx|digitalis": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|diuretic": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|dobutamine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|dopamine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|ear_nose_throat": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"htx|ebv_serology": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"htx|ebv_serology_igg": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"htx|ecg_procedure": [
			{
				id: "ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"htx|echocardiography": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|echocardiography_summary": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|edd": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|ejection_fraction": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|estimated_right_ventricular_peak_systolic_pressure": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|flu_shot": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|fvs": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"htx|gfr": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"htx|ggt": [
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"htx|got": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"htx|gpt": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"htx|gynecology_result": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"htx|haemoglobin": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"htx|hav_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|hbc_ab_igg": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbc_ab_igm": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbs_ab": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbs_ag": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbv_status": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"htx|hbv_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|heart_asist_system_therapy": [
			{
				id: "heartAssistSystemTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_assist_system_therapy"
			}
		],
		"htx|heart_failure_etiology": [
			{
				id: "heartFailureEtiology",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_etiology"
			}
		],
		"htx|heart_failure_medical_therapy": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|heart_failure_medical_therapy_other_medicine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|heart_rate": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"htx|heart_rate_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|height": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"htx|hepa_c_virus_screening": [
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.hcv"
			}
		],
		"htx|hgb_a1_c": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"htx|hiv_screening": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"htx|hospitalizations": [
			{
				id: "hospitalizations",
				isLimitedAccess: false,
				titleMessageId: "form.hospitalizations"
			}
		],
		"htx|hpv_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|hr": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|hsv1_serology": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"htx|hsv1_serology_igg": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"htx|hsv2_serology": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"htx|hsv2_serology_igg": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"htx|hyper_immunised": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|inr": [
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"htx|ivabradine": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|karbamid": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"htx|lab_bloodcount": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"htx|lab_diab": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"htx|lab_endocrin": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"htx|lab_hepat": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"htx|lab_inflamm": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"htx|lab_neph": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"htx|ldh": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"htx|left_atrial_diameter1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|left_atrial_diameter2": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|levosimendan": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|mammography_result": [
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			}
		],
		"htx|mcs": [
			{
				id: "heartAssistSystemTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_assist_system_therapy"
			}
		],
		"htx|medical_history_summary": [
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"htx|meningococcus_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|mental_health_review": [
			{
				id: "mentalHealthReview",
				isLimitedAccess: false,
				titleMessageId: "form.mental_health_review"
			}
		],
		"htx|mitral_insufficiency": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|mpap": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|mpcwp": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|mra": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|natrium": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"htx|number_of_thoracotomies": [
			{
				id: "thoracotomies",
				isLimitedAccess: false,
				titleMessageId: "form.thoracotomies"
			}
		],
		"htx|nyha_stage": [
			{
				id: "nyha",
				isLimitedAccess: false,
				titleMessageId: "form.nyha"
			}
		],
		"htx|ophthalmologic_examination_result": [
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			}
		],
		"htx|pacemaker_therapy": [
			{
				id: "pacemakerTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.pacemaker_therapy"
			}
		],
		"htx|papanicolaou": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"htx|papd": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|paps": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|patient_condition": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|patient_condition_report": [
			{
				id: "patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"htx|patient_et_id": [
			{
				id: "coordination",
				isLimitedAccess: false,
				titleMessageId: "form.coordination"
			}
		],
		"htx|patient_statement_of_consent": [
			{
				id: "patientStatementOfConsent",
				isLimitedAccess: false,
				titleMessageId: "form.patient_statement_of_consent"
			}
		],
		"htx|patient_status": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|pde_inhibitor": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|platelet_count": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"htx|pneumococus_vaccination": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"htx|posterior_wall_thickness": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|potassium": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"htx|pra_cdc": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"htx|pra_luminex": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"htx|prealbumin": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"htx|prostate_specific_antigen_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"htx|proteinuria_result": [
			{
				id: "proteinuria",
				isLimitedAccess: false,
				titleMessageId: "form.proteinuria"
			}
		],
		"htx|psa": [
			{
				id: "psa",
				isLimitedAccess: false,
				titleMessageId: "form.psa"
			}
		],
		"htx|pseudocholinesterase": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"htx|psychiatry_result": [
			{
				id: "psychiatry",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatry"
			}
		],
		"htx|pulmonary_artery_diastolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_artery_mean_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_artery_systolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_artery_wedge_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_valve_ventriculoarterial_gradient_post": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonary_vascular_resistance_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|pulmonology_result": [
			{
				id: "pulmonology",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonology"
			}
		],
		"htx|pvr": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rh": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"htx|right_atrial_diameter1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|right_atrial_diameter2": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|right_heart_catheterization": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|right_ventricular_diastolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|right_ventricular_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|right_ventricular_systolic_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rrs": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rv_size": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|rvpd": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rvpm": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|rvps": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|seen_by_anesthetist": [
			{
				id: "anesthesiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.anesthesiologist_opinion"
			}
		],
		"htx|seen_by_diabetologist": [
			{
				id: "diabetologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.diabetologist_opinion"
			}
		],
		"htx|seen_by_endocrinologist": [
			{
				id: "endocrinologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.endocrinologist_opinion"
			}
		],
		"htx|seen_by_gastroenterologist": [
			{
				id: "gastroenterologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.gastroenterologist_opinion"
			}
		],
		"htx|seen_by_geneticist": [
			{
				id: "geneticistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.geneticist_opinion"
			}
		],
		"htx|seen_by_hematologist": [
			{
				id: "hematologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hematologist_opinion"
			}
		],
		"htx|seen_by_hepatologist": [
			{
				id: "hepatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hepatologist_opinion"
			}
		],
		"htx|seen_by_immunologist": [
			{
				id: "immunologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.immunologist_opinion"
			}
		],
		"htx|seen_by_infectologist": [
			{
				id: "infectologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.infectologist_opinion"
			}
		],
		"htx|seen_by_nephrologist": [
			{
				id: "nephrologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.nephrologist_opinion"
			}
		],
		"htx|seen_by_neurologist": [
			{
				id: "neurologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.neurologist_opinion"
			}
		],
		"htx|seen_by_oncologist": [
			{
				id: "oncologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.oncologist_opinion"
			}
		],
		"htx|seen_by_radiologist": [
			{
				id: "radiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.radiologist_opinion"
			}
		],
		"htx|seen_by_rheumatologist": [
			{
				id: "rheumatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.rheumatologist_opinion"
			}
		],
		"htx|seen_by_vascular_surgeon": [
			{
				id: "vascularSurgeonOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.vascular_surgeon_opinion"
			}
		],
		"htx|septal_wall_thickness": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|serum_albumin": [
			{
				id: "albumin",
				isLimitedAccess: false,
				titleMessageId: "form.albumin"
			}
		],
		"htx|serum_glucose": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"htx|signed_statement_of_consent": [
			{
				id: "patientStatementOfConsent",
				isLimitedAccess: false,
				titleMessageId: "form.patient_statement_of_consent"
			}
		],
		"htx|smoking": [
			{
				id: "smoking",
				isLimitedAccess: false,
				titleMessageId: "form.smoking"
			}
		],
		"htx|social_worker_review": [
			{
				id: "socialWorkerReview",
				isLimitedAccess: false,
				titleMessageId: "form.social_worker_review"
			}
		],
		"htx|spect_summary": [
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"htx|spiro_fields": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|statin": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|stool_blood_result": [
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			}
		],
		"htx|stool_culture_result": [
			{
				id: "stoolculture",
				isLimitedAccess: false,
				titleMessageId: "form.stoolculture"
			}
		],
		"htx|summary_of_alcohol_use": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"htx|summary_of_thoracotomies": [
			{
				id: "thoracotomies",
				isLimitedAccess: false,
				titleMessageId: "form.thoracotomies"
			}
		],
		"htx|summary_report_by_cardiologist": [
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"htx|sv02": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|systolic_blood_pressure": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"htx|systolic_blood_pressure_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|t3": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"htx|t4": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"htx|toxoplasma_serology": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"htx|toxoplasma_serology_igg": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"htx|tpg": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|transplant_immun_concilium": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"htx|treponema_pallidum_org_screening_procedure": [
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			}
		],
		"htx|tricuspid_insufficiency": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"htx|trombocyta_aggregation_inhibitor": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"htx|tsh": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"htx|urgency": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"htx|urine_culture_result": [
			{
				id: "urineculture",
				isLimitedAccess: false,
				titleMessageId: "form.urineculture"
			}
		],
		"htx|urine_sediment_result": [
			{
				id: "urinesediment",
				isLimitedAccess: false,
				titleMessageId: "form.urinesediment"
			}
		],
		"htx|urology_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"htx|varicella_serology": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"htx|varicella_serology_igg": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"htx|vasoreactivity_test": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|venous_oxygen_saturation_post_vasodilatation": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"htx|vo2": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"htx|waiting_list_start_date": [
			{
				id: "coordination",
				isLimitedAccess: false,
				titleMessageId: "form.coordination"
			}
		],
		"htx|weight": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|10230-1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|10331-7": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|11154-2": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"loinc|11524-6": [
			{
				id: "ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"loinc|13946-9": [
			{
				id: "coombsDirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_direct"
			},
			{
				id: "coombsIndirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_indirect"
			}
		],
		"loinc|14338-8": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"loinc|14631-6": [
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"loinc|14920-3": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"loinc|14928-6": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"loinc|14937-7": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"loinc|16954-0": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"loinc|1742-6": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"loinc|1751-7": [
			{
				id: "albumin",
				isLimitedAccess: false,
				titleMessageId: "form.albumin"
			}
		],
		"loinc|18066-1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18112-3": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18113-1": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18115-6": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|18746-8": [
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			}
		],
		"loinc|19162-7": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"loinc|1920-8": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"loinc|1988-5": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"loinc|20464-4": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"loinc|2160-0": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"loinc|22244-8": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"loinc|22322-2": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|22580-5": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"loinc|2324-2": [
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"loinc|24325-3": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"loinc|24362-6": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"loinc|24616-5": [
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			}
		],
		"loinc|24748-6": [
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			}
		],
		"loinc|25020": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"loinc|2532-0": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"loinc|26515-7": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"loinc|2711-0": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|29463-7": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|2947-0": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"loinc|31204-1": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|3140-1": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|32685-0": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|33762-6": [
			{
				id: "bnp",
				isLimitedAccess: false,
				titleMessageId: "form.bnp"
			},
			{
				id: "ntProBNP",
				isLimitedAccess: false,
				titleMessageId: "form.nt_pro_bnp"
			}
		],
		"loinc|33914-3": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"loinc|34530-6": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|34714-6": [
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"loinc|34851-6": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"loinc|36572-6": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"loinc|39156-5": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|39480-9": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"loinc|407367": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"loinc|42148-7": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"loinc|43111-4": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"loinc|44137-8": [
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			}
		],
		"loinc|49178-7": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"loinc|50196-5": [
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			}
		],
		"loinc|5195-3": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"loinc|53764-7": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"loinc|5418-8": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|55112-7": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			},
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			},
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			},
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			},
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			},
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			},
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"loinc|55429-5": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"loinc|58271-8": [
			{
				id: "pacemakerTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.pacemaker_therapy"
			}
		],
		"loinc|58744-4": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			}
		],
		"loinc|60842-2": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"loinc|60985-9": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|6298-4": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"loinc|64098-7": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"loinc|64663-8": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|6690-2": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"loinc|6768-6": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"loinc|718-7": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"loinc|72056-5": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|72057-3": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|72058-1": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|75919-1": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|76269-0": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"loinc|77194-9": [
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			}
		],
		"loinc|78930-5": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|80737-0": [
			{
				id: "sensitization",
				isLimitedAccess: false,
				titleMessageId: "form.sensitization"
			}
		],
		"loinc|80994-7": [
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			}
		],
		"loinc|82593-5": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"loinc|82654-5": [
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"loinc|8302-2": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|8377-4": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8385-7": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8406-1": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8414-5": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8432-7": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8440-0": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|8462-4": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"loinc|8480-6": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"loinc|8587-8": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|86910-7": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"loinc|8741-1": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|88020-3": [
			{
				id: "nyha",
				isLimitedAccess: false,
				titleMessageId: "form.nyha"
			}
		],
		"loinc|8828-6": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"loinc|883-9": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|8867-4": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"loinc|94141-9": [
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			}
		],
		"snomed|1030791000000100": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|103306004": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"snomed|104305007": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"snomed|104321002": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"snomed|104326007": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|105011006": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"snomed|111287006": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|112143006": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|113075003": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"snomed|1142178009": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|117010004": [
			{
				id: "urineculture",
				isLimitedAccess: false,
				titleMessageId: "form.urineculture"
			}
		],
		"snomed|117028002": [
			{
				id: "stoolculture",
				isLimitedAccess: false,
				titleMessageId: "form.stoolculture"
			}
		],
		"snomed|117739006": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"snomed|118227000": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|118433006": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|128178001": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|129714008": [
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			}
		],
		"snomed|15167005": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|15240007": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|165994006": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			},
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			},
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			},
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			},
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			},
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|166324000": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"snomed|166329005": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"snomed|169069000": [
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			}
		],
		"snomed|170337005": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|170865004": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"snomed|170945005": [
			{
				id: "dermatology",
				isLimitedAccess: false,
				titleMessageId: "form.dermatology"
			},
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			}
		],
		"snomed|171121004": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"snomed|177765008": [
			{
				id: "thoracotomies",
				isLimitedAccess: false,
				titleMessageId: "form.thoracotomies"
			}
		],
		"snomed|185283008": [
			{
				id: "socialWorkerReview",
				isLimitedAccess: false,
				titleMessageId: "form.social_worker_review"
			}
		],
		"snomed|19030005": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"snomed|1951000175101": [
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"snomed|20135006": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			},
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			},
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			},
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			},
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			},
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			},
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			},
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.hcv"
			},
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			},
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			},
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			},
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			},
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			},
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			},
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			},
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			},
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			},
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			},
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			},
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			},
			{
				id: "dermatology",
				isLimitedAccess: false,
				titleMessageId: "form.dermatology"
			},
			{
				id: "dexa",
				isLimitedAccess: false,
				titleMessageId: "form.dexa"
			},
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			},
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			},
			{
				id: "mammography",
				isLimitedAccess: false,
				titleMessageId: "form.mammography"
			},
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			},
			{
				id: "psychiatry",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatry"
			},
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			},
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|219006": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|224238005": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|23901000087101": [
			{
				id: "hepatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hepatologist_opinion"
			}
		],
		"snomed|241439007": [
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			}
		],
		"snomed|241547009": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			}
		],
		"snomed|241620005": [
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			}
		],
		"snomed|241686001": [
			{
				id: "dexa",
				isLimitedAccess: false,
				titleMessageId: "form.dexa"
			}
		],
		"snomed|2425002": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"snomed|243806009": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			},
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			},
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			},
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			},
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			},
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			},
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			},
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"snomed|248326004": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|250644007": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"snomed|250768007": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|250769004": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|250770003": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|250908004": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|250929008": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|250964004": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|251086009": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|251088005": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|252478000": [
			{
				id: "6mwt",
				isLimitedAccess: false,
				titleMessageId: "form.6mwt"
			}
		],
		"snomed|26958001": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"snomed|271649006": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|271650006": [
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|276756009": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|276772001": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|276773006": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|276901002": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|281789004": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|29738008": [
			{
				id: "proteinuria",
				isLimitedAccess: false,
				titleMessageId: "form.proteinuria"
			}
		],
		"snomed|30200007": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"snomed|305634004": [
			{
				id: "anesthesiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.anesthesiologist_opinion"
			}
		],
		"snomed|305635003": [
			{
				id: "oncologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.oncologist_opinion"
			}
		],
		"snomed|305657005": [
			{
				id: "hematologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.hematologist_opinion"
			}
		],
		"snomed|305666009": [
			{
				id: "immunologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.immunologist_opinion"
			}
		],
		"snomed|305671002": [
			{
				id: "endocrinologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.endocrinologist_opinion"
			}
		],
		"snomed|305672009": [
			{
				id: "gastroenterologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.gastroenterologist_opinion"
			}
		],
		"snomed|305674005": [
			{
				id: "geneticistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.geneticist_opinion"
			}
		],
		"snomed|305683000": [
			{
				id: "nephrologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.nephrologist_opinion"
			}
		],
		"snomed|305688009": [
			{
				id: "rheumatologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.rheumatologist_opinion"
			}
		],
		"snomed|305701006": [
			{
				id: "radiologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.radiologist_opinion"
			}
		],
		"snomed|305710003": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"snomed|305729009": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|305730004": [
			{
				id: "vascularSurgeonOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.vascular_surgeon_opinion"
			}
		],
		"snomed|307280005": [
			{
				id: "pacemakerTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.pacemaker_therapy"
			}
		],
		"snomed|308118002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|312468003": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"snomed|312469006": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"snomed|313587003": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|313604004": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"snomed|313954007": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"snomed|315053001": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|315199001": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"snomed|33367005": [
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			}
		],
		"snomed|33747003": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"snomed|34043003": [
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			}
		],
		"snomed|34608000": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"snomed|3545003": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|359986008": [
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"snomed|363783003": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|363808001": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|364075005": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			},
			{
				id: "vitalSigns",
				isLimitedAccess: false,
				titleMessageId: "form.vital_signs"
			}
		],
		"snomed|365636006": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|365809007": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"snomed|365981007": [
			{
				id: "smoking",
				isLimitedAccess: false,
				titleMessageId: "form.smoking"
			}
		],
		"snomed|371534008": [
			{
				id: "cCt",
				isLimitedAccess: false,
				titleMessageId: "form.c_ct"
			},
			{
				id: "cMri",
				isLimitedAccess: false,
				titleMessageId: "form.c_mri"
			},
			{
				id: "coronarography",
				isLimitedAccess: false,
				titleMessageId: "form.coronarography"
			},
			{
				id: "cPet",
				isLimitedAccess: false,
				titleMessageId: "form.c_pet"
			},
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			},
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			},
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			},
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|372603003": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372695000": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372733002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372813008": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372862008": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|372913009": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|373254001": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|386100006": [
			{
				id: "urinesediment",
				isLimitedAccess: false,
				titleMessageId: "form.urinesediment"
			}
		],
		"snomed|387135004": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|387145002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|387521006": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|39031000119103": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|390842003": [
			{
				id: "diabetologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.diabetologist_opinion"
			}
		],
		"snomed|39361000119108": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|394719009": [
			{
				id: "carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "form.carotis_doppler"
			}
		],
		"snomed|395043005": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"snomed|396550006": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			},
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			},
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"snomed|39748002": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"snomed|399023006": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|399208008": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"snomed|401061005": [
			{
				id: "mentalHealthReview",
				isLimitedAccess: false,
				titleMessageId: "form.mental_health_review"
			}
		],
		"snomed|401221002": [
			{
				id: "abi",
				isLimitedAccess: false,
				titleMessageId: "form.abi"
			}
		],
		"snomed|40701008": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|408218006": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"snomed|408864009": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|410006001": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|410513005": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|412383006": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|416683003": [
			{
				id: "hospitalizations",
				isLimitedAccess: false,
				titleMessageId: "form.hospitalizations"
			}
		],
		"snomed|421228002": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|43396009": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"snomed|43941000119105": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|440614003": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"snomed|442349007": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|442516004": [
			{
				id: "stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "form.stool_blood"
			}
		],
		"snomed|44277000": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"snomed|442795003": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|444562008": [
			{
				id: "pulmonology",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonology"
			}
		],
		"snomed|447113005": [
			{
				id: "ekg",
				isLimitedAccess: false,
				titleMessageId: "form.ekg"
			}
		],
		"snomed|447346005": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"snomed|45036003": [
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			}
		],
		"snomed|45896001": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"snomed|47758006": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|48724000": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|50373000": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|50506008": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|50684000": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"snomed|54247002": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|54555005": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|54993008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|55235003": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"snomed|60234000": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|60621009": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|61167004": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"snomed|61928009": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"snomed|62889000": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|62944002": [
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.hcv"
			}
		],
		"snomed|63476009": [
			{
				id: "psa",
				isLimitedAccess: false,
				titleMessageId: "form.psa"
			}
		],
		"snomed|64253000": [
			{
				id: "heartAssistSystemTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_assist_system_therapy"
			}
		],
		"snomed|65677008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|65911000": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.hbv_status"
			}
		],
		"snomed|69480007": [
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"snomed|709549003": [
			{
				id: "spect",
				isLimitedAccess: false,
				titleMessageId: "form.spect"
			}
		],
		"snomed|711047004": [
			{
				id: "neurologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.neurologist_opinion"
			}
		],
		"snomed|712756001": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|713127001": [
			{
				id: "alcohol",
				isLimitedAccess: false,
				titleMessageId: "form.alcohol"
			}
		],
		"snomed|71420008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|716579001": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|723279008": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|72904005": [
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			}
		],
		"snomed|73701000119109": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"snomed|73761001": [
			{
				id: "colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopy"
			}
		],
		"snomed|74427007": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"snomed|74732009": [
			{
				id: "psychiatry",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatry"
			}
		],
		"snomed|762994006": [
			{
				id: "nyha",
				isLimitedAccess: false,
				titleMessageId: "form.nyha"
			}
		],
		"snomed|767002": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"snomed|76899008": [
			{
				id: "infectologistOpinion",
				isLimitedAccess: false,
				titleMessageId: "form.infectologist_opinion"
			}
		],
		"snomed|771452004": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|77465005": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|777480008": [
			{
				id: "heartFailureMedicalTherapy",
				isLimitedAccess: false,
				titleMessageId: "form.heart_failure_medical_therapy"
			}
		],
		"snomed|7928001": [
			{
				id: "cardiopulmonaryStressTest",
				isLimitedAccess: false,
				titleMessageId: "form.cardiopulmonary_stress_test"
			}
		],
		"snomed|80274001": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"snomed|8128003": [
			{
				id: "echocardiography",
				isLimitedAccess: false,
				titleMessageId: "form.echocardiography"
			}
		],
		"snomed|82799009": [
			{
				id: "rightHeartCatheterization",
				isLimitedAccess: false,
				titleMessageId: "form.right_heart_catheterization"
			}
		],
		"snomed|88810008": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"snomed|89780004": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|99501000119107": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.htx_vaccination_status"
			}
		],
		"srtr|can_hgt_cm": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"srtr|can_most_recent_wgt_kg7": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		]
	},
	kd: {
		"fyrms|action": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			},
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			},
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			},
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			},
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			},
			{
				id: "ktx_pregnanciesAndChildren",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.pregnancies_and_children.title"
			},
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			},
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			},
			{
				id: "ktx_alcohol",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.alcohol"
			},
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"fyrms|unstructured_field": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|APD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|CAPD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|COPD": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|Coronary_artery_disease_non_obstructive": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|Coronary_artery_disease_obstructive_with_intervention": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|Coronary_artery_disease_obstructive_without_intervention": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|GERD_ulcus": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|HBV_status_PCR_negative": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|HBV_status_PCR_positive": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|HBV_status_unknown": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|HCV_status_PCR_negative": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|HCV_status_PCR_positive": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|HCV_status_unknown": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|HD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|HHD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|IgA_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|Lead_induced_nephropathy_interstitial": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|Nephropathy_interstitial_due_to_cis-platinum": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|NoRTT_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|TIA_ischemic_stroke": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|ab0": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|abdominal-pelvis_ultrasound": [
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			}
		],
		"ktx|abdominal_CT_MR_angiography": [
			{
				id: "ktx_abdominalCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_ct_mr_angiography.title"
			}
		],
		"ktx|access": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_arteriovenous_fistula": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_other": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_permanent_catheter": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_statement": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_temporary_catheter": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_tenckhoff_catheter": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|acute_chronic_liver_failure": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|acute_rejection": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|adenotomia": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|adrenal_disfunction": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|alcohol_statement": [
			{
				id: "ktx_alcohol",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.alcohol"
			}
		],
		"ktx|alcoholic_liver_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|allergy_latex": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|amino_acid_metabolic_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|amyloid": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|amyloidosis_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|anaemia_type": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|antropometrics_examination": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|aorta_aneurysm": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|aortic_stenosis_or_insufficiency": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|appendectomia": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|asthma_bronchiale": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|atherosclerosis_arteriae_carotideae": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|atrial_fibrillation_or_other_arrythmia": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|autoimmun_baseline_disease": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|balkan_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|blood_group": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|blood_pressure": [
			{
				id: "ktx_bloodPressure",
				isLimitedAccess: false,
				titleMessageId: "ktx.blood_pressure.title"
			}
		],
		"ktx|bmi": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|bsa_dubois": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|bsa_monsteller": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|cardiology": [
			{
				id: "ktx_bikeErgometry",
				isLimitedAccess: false,
				titleMessageId: "ktx.bike_ergometry.title"
			},
			{
				id: "ktx_coronarography",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronarography.title"
			},
			{
				id: "ktx_coronaryCt",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronary_ct.title"
			},
			{
				id: "ktx_dse",
				isLimitedAccess: false,
				titleMessageId: "ktx.dse.title"
			},
			{
				id: "ktx_ekg",
				isLimitedAccess: false,
				titleMessageId: "ktx.ekg.title"
			},
			{
				id: "ktx_hearthMri",
				isLimitedAccess: false,
				titleMessageId: "ktx.hearth_mri.title"
			},
			{
				id: "ktx_spect",
				isLimitedAccess: false,
				titleMessageId: "ktx.spect.title"
			},
			{
				id: "ktx_transtorachalisEcho",
				isLimitedAccess: false,
				titleMessageId: "ktx.transtorachalis_echo.title"
			}
		],
		"ktx|cardiology_bike_ergometry": [
			{
				id: "ktx_bikeErgometry",
				isLimitedAccess: false,
				titleMessageId: "ktx.bike_ergometry.title"
			}
		],
		"ktx|cardiology_coronarography": [
			{
				id: "ktx_coronarography",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronarography.title"
			}
		],
		"ktx|cardiology_coronary_ct": [
			{
				id: "ktx_coronaryCt",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronary_ct.title"
			}
		],
		"ktx|cardiology_dse": [
			{
				id: "ktx_dse",
				isLimitedAccess: false,
				titleMessageId: "ktx.dse.title"
			}
		],
		"ktx|cardiology_ekg": [
			{
				id: "ktx_ekg",
				isLimitedAccess: false,
				titleMessageId: "ktx.ekg.title"
			}
		],
		"ktx|cardiology_hearth_mri": [
			{
				id: "ktx_hearthMri",
				isLimitedAccess: false,
				titleMessageId: "ktx.hearth_mri.title"
			}
		],
		"ktx|cardiology_opinion": [
			{
				id: "ktx_cardiologyOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.cardiology_opinion.title"
			}
		],
		"ktx|cardiology_spect": [
			{
				id: "ktx_spect",
				isLimitedAccess: false,
				titleMessageId: "ktx.spect.title"
			}
		],
		"ktx|cardiology_transtorachalis_echo": [
			{
				id: "ktx_transtorachalisEcho",
				isLimitedAccess: false,
				titleMessageId: "ktx.transtorachalis_echo.title"
			}
		],
		"ktx|cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|cardiovascular_disease_type": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|carotis_doppler": [
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			}
		],
		"ktx|cause_of_graftloss": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|cerebral_sinus_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|cerebrum_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|cervix_uteri_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|chest_ct": [
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			}
		],
		"ktx|chest_x_ray": [
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			}
		],
		"ktx|cholecysta_pancreas_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|cholecystectomia_LC": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|chronic_rejection": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|chronic_renal_failure": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|coid_vaccination_COVAX-19": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|colonoscopy": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			}
		],
		"ktx|combined_organ_transplantation": [
			{
				id: "ktx_combinedOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.combined_organ_transplantation.title"
			}
		],
		"ktx|comment_for_blood_group": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|congenital_renal_dysplasia": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|connective_tissue_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|consultation procedure": [
			{
				id: "ktx_cardiologyOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.cardiology_opinion.title"
			},
			{
				id: "ktx_diabetology",
				isLimitedAccess: false,
				titleMessageId: "ktx.diabetology.title"
			},
			{
				id: "ktx_endocrinology",
				isLimitedAccess: false,
				titleMessageId: "ktx.endocrinology.title"
			},
			{
				id: "ktx_gastroenterology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gastroenterology.title"
			},
			{
				id: "ktx_genetics",
				isLimitedAccess: false,
				titleMessageId: "ktx.genetics.title"
			},
			{
				id: "ktx_hematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hematology.title"
			},
			{
				id: "ktx_hepatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hepatology.title"
			},
			{
				id: "ktx_immunology",
				isLimitedAccess: false,
				titleMessageId: "ktx.immunology.title"
			},
			{
				id: "ktx_neurology",
				isLimitedAccess: false,
				titleMessageId: "ktx.neurology.title"
			},
			{
				id: "ktx_oncology",
				isLimitedAccess: false,
				titleMessageId: "ktx.oncology.title"
			},
			{
				id: "ktx_psychiatry",
				isLimitedAccess: false,
				titleMessageId: "ktx.psychiatry.title"
			},
			{
				id: "ktx_pulmonology",
				isLimitedAccess: false,
				titleMessageId: "ktx.pulmonology.title"
			},
			{
				id: "ktx_transplantAnesthesiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantAnesthesiology.title"
			},
			{
				id: "ktx_transplantNephrology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantNephrology.title"
			},
			{
				id: "ktx_transplantSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantSurgery.title"
			},
			{
				id: "ktx_vascularSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.vascularSurgery.title"
			}
		],
		"ktx|coronary_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|corpus_uteri_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|covid_disease": [
			{
				id: "ktx_covidDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_disease.title"
			}
		],
		"ktx|covid_vaccination": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Abdala": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_COVIran_Barekat": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Chinese_Academy_of_Medical_Sciences": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_CoVLP": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Convidecia": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Corbevax": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_CoronaVac": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Covaxin": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_CoviVac": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_EpiVacCorona": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Evusheld": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_FAKHRAVAC": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Janssen": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Medigen": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Minhai": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Moderna": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Noora": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Novavax": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Oxford–AstraZeneca": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Pfizer–BioNTech": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_QazCovid-in": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Razi_Cov_Pars": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_SKYCovione": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sinopharm": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sinopharm_NVSI": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sinopharm_WIBP": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Soberana_02": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Soberana_Plus": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sputnik": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sputnik_Light": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Turkovac": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_VLA2001": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Zifivax": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_ZyCoV-D6": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_no": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_type": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_unknown": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|cranium_CT_MR_angiography": [
			{
				id: "ktx_craniumCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.cranium_ct_mr_angiography.title"
			}
		],
		"ktx|crescentic": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cryoglobulinaemic_glomerulonephritis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cystic_kidney_disease_other_specified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cystic_kidney_disease_unspecified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cystinosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|de_novo_kidney_disease": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|death_with_functioning_graft": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|dementia": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|dense_deposit_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|dental_screening": [
			{
				id: "ktx_dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.dentalScreening.title"
			}
		],
		"ktx|dermatology": [
			{
				id: "ktx_dermatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.dermatology.title"
			}
		],
		"ktx|diabetes": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|diabetes_type_I": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|diabetes_type_II": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|diabetology": [
			{
				id: "ktx_diabetology",
				isLimitedAccess: false,
				titleMessageId: "ktx.diabetology.title"
			}
		],
		"ktx|dialatative_cardiomyopathy": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|drug_induced_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|drug_type": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_OAC_NOAC": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_acei": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_acethylsalicilate": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_amiodarone": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_amlodipine_dhp": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_arb": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_beta_receptor inhibitor": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_calcium_contain_phospphate_binders": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_clopidogrel": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_diuretics": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_erythropoetin_product": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_nonDHP": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_other": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_other_TAGs_thrombocyte_aggregation_inhibitors": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_vitamine_D_product": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|ear_nose_throat": [
			{
				id: "ktx_earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "ktx.earNoseThroat.title"
			}
		],
		"ktx|endocrinology": [
			{
				id: "ktx_endocrinology",
				isLimitedAccess: false,
				titleMessageId: "ktx.endocrinology.title"
			}
		],
		"ktx|eyes_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|fabrys_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|focal_segmental_glomerulosclerosis_in_adults": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|focal_segmental_glomerulosclerosis_in_children": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|food_allergy": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_gluten": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_lactose": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_no": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_other": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|gastroenterology": [
			{
				id: "ktx_gastroenterology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gastroenterology.title"
			}
		],
		"ktx|genetics": [
			{
				id: "ktx_genetics",
				isLimitedAccess: false,
				titleMessageId: "ktx.genetics.title"
			}
		],
		"ktx|glandula_salivaris_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|glandula_thyroida_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|glomerulonephritis_histologically_examined": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|glomerulonephritis_histologically_not_examined": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|glomerulonephritis_related_to_liver_cirrhosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|goodpastures_syndrome": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|gout": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|graft_infection": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|graftectomy": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|graftectomy_ld": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|graftectomy_ls": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|graftloss_statement": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|gynecology": [
			{
				id: "ktx_gynecology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gynecology.title"
			}
		],
		"ktx|haemolytic_uraemic_syndrome": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|haemorrhagic_stroke": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|haemostaseology": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|haemostaseology_type": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|haemostaseology_type_other": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|has_cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|has_cardiovascular_disease_choice": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|has_graftloss": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|has_graftloss_choice": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|has_haemostaseology_disease": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|has_haemostaseology_disease_choice": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|has_metabolic_disease": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|has_metabolic_disease_choice": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|has_nephrectomy_graftectomy_disease": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|has_nephrectomy_graftectomy_disease_choice": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|has_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|has_oncology_disease_choice": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|has_other_disorder_disease": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|has_other_disorder_disease_choice": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|has_other_surgical_intervention": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|has_other_surgical_intervention_choice": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|has_previous_other_organ_transplantation": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|has_previous_other_organ_transplantation_choice": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|has_renal_anaemia_hepatology_disease": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|has_renal_anaemia_hepatology_disease_choice": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|hbv_chronic_liver_failure_statement": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|hcv_chronic_liver_failure_statement": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|height": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|hematology": [
			{
				id: "ktx_hematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hematology.title"
			}
		],
		"ktx|henoch_Schoenlein_purpura": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hepatology": [
			{
				id: "ktx_hepatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hepatology.title"
			}
		],
		"ktx|hepatology_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|hepatology_no_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|hereditary_Familial_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hereditary_nephritis_with_nerve_deafness": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hereditary_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hernioplastica_inguinalis_ld": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|hernioplastica_inguinalis_ls": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|hernoplastica_par_abdominalis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|hodgkin_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|hyperthrophic_cardiomyopathy": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|hyperthyreosis": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|hypothyreosis": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|imaging_procedure": [
			{
				id: "ktx_abdominalCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_ct_mr_angiography.title"
			},
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			},
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			},
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			},
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			},
			{
				id: "ktx_craniumCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.cranium_ct_mr_angiography.title"
			},
			{
				id: "ktx_lowerLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.lower_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_nativeAbdominalXRay",
				isLimitedAccess: false,
				titleMessageId: "ktx.nativeAbdominalXRay.title"
			},
			{
				id: "ktx_neckCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.neck_ct_mr_angiography.title"
			},
			{
				id: "ktx_otherImagingProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.other_imaging_procedure.title"
			},
			{
				id: "ktx_upperLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_upperLimbDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_doppler.title"
			}
		],
		"ktx|immunology": [
			{
				id: "ktx_immunology",
				isLimitedAccess: false,
				titleMessageId: "ktx.immunology.title"
			}
		],
		"ktx|interstitial_nephritis_not_pyelonephritis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|ischaemic_renal_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|kaposi_sarcoma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|kidney_biopsy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|kidney_disease_ethiology": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|kidney_transplant": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|kidney_tumour": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|lab_CRP": [
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			}
		],
		"ktx|lab_HbA1c_calculated": [
			{
				id: "ktx_hgbA1CCalculated",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1CCalculated.title"
			}
		],
		"ktx|lab_HgbA1C": [
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			}
		],
		"ktx|lab_LDL_cholesterol": [
			{
				id: "ktx_ldlCholesterol",
				isLimitedAccess: false,
				titleMessageId: "ktx.ldlCholesterol.title"
			}
		],
		"ktx|lab_PSA": [
			{
				id: "ktx_psa",
				isLimitedAccess: false,
				titleMessageId: "ktx.psa.title"
			}
		],
		"ktx|lab_T3": [
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			}
		],
		"ktx|lab_T4": [
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			}
		],
		"ktx|lab_TSH": [
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			}
		],
		"ktx|lab_albumin": [
			{
				id: "ktx_albumin",
				isLimitedAccess: false,
				titleMessageId: "ktx.albumin.title"
			}
		],
		"ktx|lab_alkaline_phosphatase": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			}
		],
		"ktx|lab_bilirubin_direct": [
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			}
		],
		"ktx|lab_bilirubin_total": [
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			}
		],
		"ktx|lab_calcium": [
			{
				id: "ktx_calcium",
				isLimitedAccess: false,
				titleMessageId: "ktx.calcium.title"
			}
		],
		"ktx|lab_combined_kidney_pancreas": [
			{
				id: "ktx_combinedKidneyPancreas",
				isLimitedAccess: false,
				titleMessageId: "ktx.combinedKidneyPancreas.title"
			}
		],
		"ktx|lab_creatinine": [
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			}
		],
		"ktx|lab_eGFR": [
			{
				id: "ktx_eGfr",
				isLimitedAccess: false,
				titleMessageId: "ktx.eGfr.title"
			}
		],
		"ktx|lab_fasting_glucose": [
			{
				id: "ktx_fastingGlucose",
				isLimitedAccess: false,
				titleMessageId: "ktx.fastingGlucose.title"
			}
		],
		"ktx|lab_ferritine": [
			{
				id: "ktx_ferritine",
				isLimitedAccess: false,
				titleMessageId: "ktx.ferritine.title"
			}
		],
		"ktx|lab_ggt": [
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			}
		],
		"ktx|lab_got": [
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			}
		],
		"ktx|lab_gpt": [
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			}
		],
		"ktx|lab_haemoglobin": [
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			}
		],
		"ktx|lab_iPTH": [
			{
				id: "ktx_iPth",
				isLimitedAccess: false,
				titleMessageId: "ktx.iPth.title"
			}
		],
		"ktx|lab_inr": [
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			}
		],
		"ktx|lab_other_procedure": [
			{
				id: "ktx_otherLabProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.otherLabProcedure.title"
			}
		],
		"ktx|lab_phosphate": [
			{
				id: "ktx_phosphate",
				isLimitedAccess: false,
				titleMessageId: "ktx.phosphate.title"
			}
		],
		"ktx|lab_potassium": [
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			}
		],
		"ktx|lab_procedure": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			},
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			},
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			},
			{
				id: "ktx_calcium",
				isLimitedAccess: false,
				titleMessageId: "ktx.calcium.title"
			},
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			},
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			},
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			},
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			},
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			},
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			},
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			},
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			},
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			},
			{
				id: "ktx_phosphate",
				isLimitedAccess: false,
				titleMessageId: "ktx.phosphate.title"
			},
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			},
			{
				id: "ktx_psa",
				isLimitedAccess: false,
				titleMessageId: "ktx.psa.title"
			},
			{
				id: "ktx_stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolBlood.title"
			},
			{
				id: "ktx_stoolculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolculture.title"
			},
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			},
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			},
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			},
			{
				id: "ktx_urineculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineculture.title"
			},
			{
				id: "ktx_urineProteinCreatinineRatio",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineProteinCreatinineRatio.title"
			}
		],
		"ktx|lab_rest_diuresis": [
			{
				id: "ktx_restDiuresis",
				isLimitedAccess: false,
				titleMessageId: "ktx.restDiuresis.title"
			}
		],
		"ktx|lab_serum_iron": [
			{
				id: "ktx_serumIron",
				isLimitedAccess: false,
				titleMessageId: "ktx.serumIron.title"
			}
		],
		"ktx|lab_sodium": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			}
		],
		"ktx|lab_stool_blood": [
			{
				id: "ktx_stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolBlood.title"
			}
		],
		"ktx|lab_stool_culture": [
			{
				id: "ktx_stoolculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolculture.title"
			}
		],
		"ktx|lab_thrombocyte": [
			{
				id: "ktx_thrombocyte",
				isLimitedAccess: false,
				titleMessageId: "ktx.thrombocyte.title"
			}
		],
		"ktx|lab_total_cholesterol": [
			{
				id: "ktx_totalCholesterol",
				isLimitedAccess: false,
				titleMessageId: "ktx.totalCholesterol.title"
			}
		],
		"ktx|lab_total_iron_binding_capacity": [
			{
				id: "ktx_totalIronBindingCapacity",
				isLimitedAccess: false,
				titleMessageId: "ktx.totalIronBindingCapacity.title"
			}
		],
		"ktx|lab_total_protein": [
			{
				id: "ktx_totalProtein",
				isLimitedAccess: false,
				titleMessageId: "ktx.totalProtein.title"
			}
		],
		"ktx|lab_total_urine_analysis": [
			{
				id: "ktx_totalUrineAnalysis",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.total_urine_analysis.title"
			}
		],
		"ktx|lab_transferrin_saturation": [
			{
				id: "ktx_transferrinSaturation",
				isLimitedAccess: false,
				titleMessageId: "ktx.transferrinSaturation.title"
			}
		],
		"ktx|lab_triglyceride": [
			{
				id: "ktx_triglyceride",
				isLimitedAccess: false,
				titleMessageId: "ktx.triglyceride.title"
			}
		],
		"ktx|lab_urate": [
			{
				id: "ktx_urate",
				isLimitedAccess: false,
				titleMessageId: "ktx.urate.title"
			}
		],
		"ktx|lab_urea_nitrogen": [
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			}
		],
		"ktx|lab_urine_culture": [
			{
				id: "ktx_urineculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineculture.title"
			}
		],
		"ktx|lab_urine_protein_creatinine_ratio": [
			{
				id: "ktx_urineProteinCreatinineRatio",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineProteinCreatinineRatio.title"
			}
		],
		"ktx|lab_white_blood_cell_count": [
			{
				id: "ktx_whiteBloodCellCount",
				isLimitedAccess: false,
				titleMessageId: "ktx.whiteBloodCellCount.title"
			}
		],
		"ktx|lactose_intolerance": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|larynx_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|leukaemia_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|leukopaenia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|lipoprotein_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|lips_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|live_donor_screening": [
			{
				id: "ktx_liveDonorScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.live_donor_screening.title"
			}
		],
		"ktx|liver_failure": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|lower_limb_CT_MR_angiography": [
			{
				id: "ktx_lowerLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.lower_limb_ct_mr_angiography.title"
			}
		],
		"ktx|lower_limb_deep_vein_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|lung_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|lupus_erythematosus": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|macrocyter_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|macrovascular_consequence": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|malignant_disease_of_the_liver": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|mamma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|mammography": [
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			}
		],
		"ktx|medical_treatment_statement": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|medicine_active_ingredient": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_diagnosis": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|medicine_sensitivity": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_NSAID": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_RASI": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_acethylsalicilate": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_amlodipine": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_beta_receptor_antagonists": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_cephalosporine": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_digitalis": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_fluorocinolone": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_no": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_other": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_penicillin": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_sulfametaxasole_thrometoprim": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_vancomycin": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medullary_cystic_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|melanoma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|membrano_proliferative": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|membranous_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|mesothelioma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|metabolic_disease_type": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|metabolic_liver_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|microbiological_cmv": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			}
		],
		"ktx|microbiological_ebv": [
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			}
		],
		"ktx|microbiological_hbv_status": [
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			}
		],
		"ktx|microbiological_hcv": [
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			}
		],
		"ktx|microbiological_hiv": [
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			}
		],
		"ktx|microbiological_procedure": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			},
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			},
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			},
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			},
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			},
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			},
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			},
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"ktx|microbiological_toxoplasma": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"ktx|microbiological_treponema_pallidum": [
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			}
		],
		"ktx|microbiological_varicella": [
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"ktx|microcyter_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|microvascular_consequence": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|miscellaneous": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			},
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|mitral_stenosis_or_insufficiency": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|mouth_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|multi_system_disease_other": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|multiple_myeloma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|myelomatosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|native_abdominal_x-ray": [
			{
				id: "ktx_nativeAbdominalXRay",
				isLimitedAccess: false,
				titleMessageId: "ktx.nativeAbdominalXRay.title"
			}
		],
		"ktx|neck_CT_MR_angiography": [
			{
				id: "ktx_neckCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.neck_ct_mr_angiography.title"
			}
		],
		"ktx|neoplasms_of_bone_marrow_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|nephrectomy": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_graftectomy": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_ld": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_ls": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_lu": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrocalcinosis_hypercalcaemic_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|nephropathy_interstitial_due_to_analgesic_drugs": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|nephropathy_interstitial_due_to_cyclosporin_A": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|neurology": [
			{
				id: "ktx_neurology",
				isLimitedAccess: false,
				titleMessageId: "ktx.neurology.title"
			}
		],
		"ktx|no_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|no_unknown_cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|no_unknown_graftloss": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|no_unknown_haemostaseology_disease": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|no_unknown_metabolic_disease": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|no_unknown_nephrectomy_graftectomy_disease": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|no_unknown_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|no_unknown_other_disorder_disease": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|no_unknown_other_surgical_intervention": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|no_unknown_previous_other_organ_transplantation": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|no_unknown_renal_anaemia_hepatology_disease": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|non-complience": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|non_hodgkin_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|non_specific_graft_failure": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|nonalcoholic_fatty_liver_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|normocyter_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|oesophagus_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|oligomeganephronic_hypoplasia": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|oncology": [
			{
				id: "ktx_oncology",
				isLimitedAccess: false,
				titleMessageId: "ktx.oncology.title"
			}
		],
		"ktx|oncology_disease_type": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|ophthalmology": [
			{
				id: "ktx_ophthalmology",
				isLimitedAccess: false,
				titleMessageId: "ktx.ophthalmology.title"
			}
		],
		"ktx|other_allergy": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|other_cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|other_cause": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|other_disorder": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|other_identified_renal_disorders": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|other_imaging_procedure": [
			{
				id: "ktx_otherImagingProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.other_imaging_procedure.title"
			}
		],
		"ktx|other_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|other_surgical_intervention": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|other_surgical_intervention_other": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|other_surgical_intervention_type": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|ovarium_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|parathyreoidectomia_partialis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|parathyreoidectomia_totalis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|patient_condition_statement": [
			{
				id: "ktx_patientCondition",
				isLimitedAccess: false,
				titleMessageId: "kd.form.patient_condition.title"
			}
		],
		"ktx|patient_status_by_nephrologist": [
			{
				id: "ktx_patientCondition",
				isLimitedAccess: false,
				titleMessageId: "kd.form.patient_condition.title"
			}
		],
		"ktx|penis_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|peripheral_artery_diesease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|pituitary_malfunction": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|polycystic_kidneys_adult_type": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|polycystic_kidneys_infantile": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|polyneuropathy": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|porphyrin_and_bilirubin_metabolic_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|postrenal_causes": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|pregnancies_and_children_statement": [
			{
				id: "ktx_pregnanciesAndChildren",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.pregnancies_and_children.title"
			}
		],
		"ktx|previous_other_organ_transplantation": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_other_organ_transplantation_statement": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_bone_marrow": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_heart": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_kidney": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_liver": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_lung": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_other": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_pancreas": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|primary_hypertension": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|primary_non_function": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|primary_oxalosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|primary_renal_disease": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|prostata_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|psychiatry": [
			{
				id: "ktx_psychiatry",
				isLimitedAccess: false,
				titleMessageId: "ktx.psychiatry.title"
			}
		],
		"ktx|pulmonary_embolism": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|pulmonology": [
			{
				id: "ktx_pulmonology",
				isLimitedAccess: false,
				titleMessageId: "ktx.pulmonology.title"
			}
		],
		"ktx|purine_and_pirimidine_metabolic_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|pyelonephritis_associated_with_neurogenic_bladder": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_cause_not_specified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_acquired_obstructive_uropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_congenital_obstructive_uropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_other_cause": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_urolithiasis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_vesico-ureteric_reflux_without_obstruction":
			[
				{
					id: "ktx_kidneyDiseaseEthiology",
					isLimitedAccess: false,
					titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
				}
			],
		"ktx|renal_anaemia_hematology_statement": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|renal_anaemia_hematology_type": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|renal_hypoplasia_congenital": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_malignancy_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|renal_replacement_therapy_statement": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_hypertension": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_malignant_hypertension": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_other_cause": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_polyarteritis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_type_unspecified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|rh": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|secondary_hypertension": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|sensitivities_and_allergies_statement": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|signed_statement_of_consent_fyrms": [
			{
				id: "ktx_patientStatementOfConsentFyrms",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.patient_statement_of_consent_fyrms"
			}
		],
		"ktx|signed_statement_of_consent_ovsz": [
			{
				id: "ktx_patientStatementOfConsentOvsz",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.patient_statement_of_consent_ovsz"
			}
		],
		"ktx|skin_tumour_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|small_intestine_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|smoking_cigarettes_pack_years": [
			{
				id: "ktx_smoking",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.smoking"
			}
		],
		"ktx|smoking_statement": [
			{
				id: "ktx_smoking",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.smoking"
			}
		],
		"ktx|sphyngolipid_and_glucosaminoglycane": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|stenosis_arteriae_conorariae": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|stenosis_arteriae_renalis": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|superficial_vein_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|syndrome_of_agenesis_of_abdominal_muscles": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|systemic_sclerosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|testis_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|thrombopaenia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|thrombosis_neck_region": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|thymus_disorder": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|thyreoidectomia_partialis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|thyreoidectomia_totalis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|tonsillectomia": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|toung_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|trachea_bronchus_bronchii_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|transfusion": [
			{
				id: "ktx_transfusion",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.transfusion.title"
			}
		],
		"ktx|transplant_anesthesiology": [
			{
				id: "ktx_transplantAnesthesiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantAnesthesiology.title"
			}
		],
		"ktx|transplant_nephrology": [
			{
				id: "ktx_transplantNephrology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantNephrology.title"
			}
		],
		"ktx|transplant_surgery": [
			{
				id: "ktx_transplantSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantSurgery.title"
			}
		],
		"ktx|traumatic_or_surgical_loss_of_kidney": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|tuberculosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|tubular_necrosis_irreversible": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|tumour_research": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			},
			{
				id: "ktx_dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.dentalScreening.title"
			},
			{
				id: "ktx_dermatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.dermatology.title"
			},
			{
				id: "ktx_earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "ktx.earNoseThroat.title"
			},
			{
				id: "ktx_gynecology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gynecology.title"
			},
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			},
			{
				id: "ktx_ophthalmology",
				isLimitedAccess: false,
				titleMessageId: "ktx.ophthalmology.title"
			},
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"ktx|turp": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|unknown_cause": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|upper_limb_CT_MR_angiography": [
			{
				id: "ktx_upperLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_ct_mr_angiography.title"
			}
		],
		"ktx|upper_limb_deep_vein_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|upper_limb_doppler": [
			{
				id: "ktx_upperLimbDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_doppler.title"
			}
		],
		"ktx|ureteral_malignancy_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|urethra_malignancy_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|urology": [
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"ktx|vascular_diseases_of_the_liver": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|vascular_problems": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|vascular_surgery": [
			{
				id: "ktx_vascularSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.vascularSurgery.title"
			}
		],
		"ktx|ventriculus_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|vulva_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|wegeners_granulomatosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|weight": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|10331-7": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"loinc|14631-6": [
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			}
		],
		"loinc|14920-3": [
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			}
		],
		"loinc|14928-6": [
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			}
		],
		"loinc|14937-7": [
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			}
		],
		"loinc|1742-6": [
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			}
		],
		"loinc|1751-7": [
			{
				id: "ktx_albumin",
				isLimitedAccess: false,
				titleMessageId: "ktx.albumin.title"
			}
		],
		"loinc|18746-8": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			}
		],
		"loinc|1920-8": [
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			}
		],
		"loinc|1988-5": [
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			}
		],
		"loinc|20464-4": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"loinc|2160-0": [
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			}
		],
		"loinc|22580-5": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"loinc|2324-2": [
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			}
		],
		"loinc|24616-5": [
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			}
		],
		"loinc|25020": [
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			}
		],
		"loinc|29463-7": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|2947-0": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			}
		],
		"loinc|3140-1": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|34530-6": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"loinc|34714-6": [
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			}
		],
		"loinc|34851-6": [
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"loinc|36572-6": [
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			}
		],
		"loinc|39156-5": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|407367": [
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			}
		],
		"loinc|6298-4": [
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			}
		],
		"loinc|6768-6": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			}
		],
		"loinc|718-7": [
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			}
		],
		"loinc|8302-2": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|86910-7": [
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			}
		],
		"loinc|883-9": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"loinc|94141-9": [
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			}
		],
		"snomed|104305007": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"snomed|104326007": [
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"snomed|105011006": [
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			}
		],
		"snomed|1119418001": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"snomed|112143006": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"snomed|113075003": [
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			}
		],
		"snomed|117010004": [
			{
				id: "ktx_urineculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineculture.title"
			}
		],
		"snomed|117028002": [
			{
				id: "ktx_stoolculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolculture.title"
			}
		],
		"snomed|128178001": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|129714008": [
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			}
		],
		"snomed|165994006": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			},
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			},
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			},
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			},
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			},
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			},
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			},
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"snomed|166324000": [
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			}
		],
		"snomed|166329005": [
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			}
		],
		"snomed|166704001": [
			{
				id: "ktx_phosphate",
				isLimitedAccess: false,
				titleMessageId: "ktx.phosphate.title"
			}
		],
		"snomed|169069000": [
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			}
		],
		"snomed|170865004": [
			{
				id: "ktx_gynecology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gynecology.title"
			}
		],
		"snomed|170945005": [
			{
				id: "ktx_ophthalmology",
				isLimitedAccess: false,
				titleMessageId: "ktx.ophthalmology.title"
			}
		],
		"snomed|171121004": [
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			}
		],
		"snomed|187033005": [
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			}
		],
		"snomed|1951000175101": [
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			}
		],
		"snomed|20135006": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			},
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			},
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			},
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			},
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			},
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			},
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			},
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			},
			{
				id: "ktx_abdominalCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_ct_mr_angiography.title"
			},
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			},
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			},
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			},
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			},
			{
				id: "ktx_craniumCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.cranium_ct_mr_angiography.title"
			},
			{
				id: "ktx_lowerLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.lower_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_nativeAbdominalXRay",
				isLimitedAccess: false,
				titleMessageId: "ktx.nativeAbdominalXRay.title"
			},
			{
				id: "ktx_neckCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.neck_ct_mr_angiography.title"
			},
			{
				id: "ktx_otherImagingProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.other_imaging_procedure.title"
			},
			{
				id: "ktx_upperLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_upperLimbDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_doppler.title"
			}
		],
		"snomed|23901000087101": [
			{
				id: "ktx_hepatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hepatology.title"
			}
		],
		"snomed|2425002": [
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			}
		],
		"snomed|252407006": [
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			}
		],
		"snomed|265550007": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"snomed|26758005": [
			{
				id: "ktx_albumin",
				isLimitedAccess: false,
				titleMessageId: "ktx.albumin.title"
			}
		],
		"snomed|271240001": [
			{
				id: "ktx_calcium",
				isLimitedAccess: false,
				titleMessageId: "ktx.calcium.title"
			}
		],
		"snomed|30200007": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			}
		],
		"snomed|305634004": [
			{
				id: "ktx_transplantAnesthesiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantAnesthesiology.title"
			}
		],
		"snomed|305635003": [
			{
				id: "ktx_oncology",
				isLimitedAccess: false,
				titleMessageId: "ktx.oncology.title"
			}
		],
		"snomed|305657005": [
			{
				id: "ktx_hematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hematology.title"
			}
		],
		"snomed|305671002": [
			{
				id: "ktx_endocrinology",
				isLimitedAccess: false,
				titleMessageId: "ktx.endocrinology.title"
			}
		],
		"snomed|305672009": [
			{
				id: "ktx_gastroenterology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gastroenterology.title"
			}
		],
		"snomed|305674005": [
			{
				id: "ktx_genetics",
				isLimitedAccess: false,
				titleMessageId: "ktx.genetics.title"
			}
		],
		"snomed|305710003": [
			{
				id: "ktx_earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "ktx.earNoseThroat.title"
			}
		],
		"snomed|305729009": [
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"snomed|305730004": [
			{
				id: "ktx_vascularSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.vascularSurgery.title"
			}
		],
		"snomed|312468003": [
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			}
		],
		"snomed|312469006": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			}
		],
		"snomed|313500004": [
			{
				id: "ktx_urineProteinCreatinineRatio",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineProteinCreatinineRatio.title"
			}
		],
		"snomed|313604004": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			}
		],
		"snomed|34043003": [
			{
				id: "ktx_dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.dentalScreening.title"
			}
		],
		"snomed|34608000": [
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			}
		],
		"snomed|359986008": [
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			}
		],
		"snomed|363783003": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"snomed|363808001": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|365636006": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"snomed|365809007": [
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			}
		],
		"snomed|390842003": [
			{
				id: "ktx_diabetology",
				isLimitedAccess: false,
				titleMessageId: "ktx.diabetology.title"
			}
		],
		"snomed|394719009": [
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			}
		],
		"snomed|39748002": [
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			}
		],
		"snomed|399208008": [
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			}
		],
		"snomed|414285001": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"snomed|43396009": [
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			}
		],
		"snomed|442516004": [
			{
				id: "ktx_stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolBlood.title"
			}
		],
		"snomed|444562008": [
			{
				id: "ktx_pulmonology",
				isLimitedAccess: false,
				titleMessageId: "ktx.pulmonology.title"
			}
		],
		"snomed|45036003": [
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			}
		],
		"snomed|45896001": [
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			}
		],
		"snomed|49601007": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"snomed|50373000": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|55235003": [
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			}
		],
		"snomed|60621009": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|61167004": [
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			}
		],
		"snomed|62889000": [
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			}
		],
		"snomed|63476009": [
			{
				id: "ktx_psa",
				isLimitedAccess: false,
				titleMessageId: "ktx.psa.title"
			}
		],
		"snomed|69480007": [
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			}
		],
		"snomed|7246002": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"snomed|73761001": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			}
		],
		"snomed|74732009": [
			{
				id: "ktx_psychiatry",
				isLimitedAccess: false,
				titleMessageId: "ktx.psychiatry.title"
			}
		],
		"snomed|88810008": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			}
		],
		"srtr|can_hgt_cm": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"srtr|can_most_recent_wgt_kg7": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		]
	},
	ktx: {
		"fyrms|action": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			},
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			},
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			},
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			},
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			},
			{
				id: "ktx_pregnanciesAndChildren",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.pregnancies_and_children.title"
			},
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			},
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			},
			{
				id: "ktx_alcohol",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.alcohol"
			},
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"fyrms|unstructured_field": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|APD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|CAPD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|COPD": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|Coronary_artery_disease_non_obstructive": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|Coronary_artery_disease_obstructive_with_intervention": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|Coronary_artery_disease_obstructive_without_intervention": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|GERD_ulcus": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|HBV_status_PCR_negative": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|HBV_status_PCR_positive": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|HBV_status_unknown": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|HCV_status_PCR_negative": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|HCV_status_PCR_positive": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|HCV_status_unknown": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|HD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|HHD_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|IgA_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|Lead_induced_nephropathy_interstitial": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|Nephropathy_interstitial_due_to_cis-platinum": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|NoRTT_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|TIA_ischemic_stroke": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|ab0": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|abdominal-pelvis_ultrasound": [
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			}
		],
		"ktx|abdominal_CT_MR_angiography": [
			{
				id: "ktx_abdominalCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_ct_mr_angiography.title"
			}
		],
		"ktx|access": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_arteriovenous_fistula": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_other": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_permanent_catheter": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_statement": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_temporary_catheter": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|access_tenckhoff_catheter": [
			{
				id: "ktx_access",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.access.title"
			}
		],
		"ktx|acute_chronic_liver_failure": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|acute_rejection": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|adenotomia": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|adrenal_disfunction": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|alcohol_statement": [
			{
				id: "ktx_alcohol",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.alcohol"
			}
		],
		"ktx|alcoholic_liver_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|allergy_latex": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|amino_acid_metabolic_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|amyloid": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|amyloidosis_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|anaemia_type": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|antropometrics_examination": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|aorta_aneurysm": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|aortic_stenosis_or_insufficiency": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|appendectomia": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|asthma_bronchiale": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|atherosclerosis_arteriae_carotideae": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|atrial_fibrillation_or_other_arrythmia": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|autoimmun_baseline_disease": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|balkan_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|blood_group": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|blood_pressure": [
			{
				id: "ktx_bloodPressure",
				isLimitedAccess: false,
				titleMessageId: "ktx.blood_pressure.title"
			}
		],
		"ktx|bmi": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|bsa_dubois": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|bsa_monsteller": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|cardiology": [
			{
				id: "ktx_bikeErgometry",
				isLimitedAccess: false,
				titleMessageId: "ktx.bike_ergometry.title"
			},
			{
				id: "ktx_coronarography",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronarography.title"
			},
			{
				id: "ktx_coronaryCt",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronary_ct.title"
			},
			{
				id: "ktx_dse",
				isLimitedAccess: false,
				titleMessageId: "ktx.dse.title"
			},
			{
				id: "ktx_ekg",
				isLimitedAccess: false,
				titleMessageId: "ktx.ekg.title"
			},
			{
				id: "ktx_hearthMri",
				isLimitedAccess: false,
				titleMessageId: "ktx.hearth_mri.title"
			},
			{
				id: "ktx_spect",
				isLimitedAccess: false,
				titleMessageId: "ktx.spect.title"
			},
			{
				id: "ktx_transtorachalisEcho",
				isLimitedAccess: false,
				titleMessageId: "ktx.transtorachalis_echo.title"
			}
		],
		"ktx|cardiology_bike_ergometry": [
			{
				id: "ktx_bikeErgometry",
				isLimitedAccess: false,
				titleMessageId: "ktx.bike_ergometry.title"
			}
		],
		"ktx|cardiology_coronarography": [
			{
				id: "ktx_coronarography",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronarography.title"
			}
		],
		"ktx|cardiology_coronary_ct": [
			{
				id: "ktx_coronaryCt",
				isLimitedAccess: false,
				titleMessageId: "ktx.coronary_ct.title"
			}
		],
		"ktx|cardiology_dse": [
			{
				id: "ktx_dse",
				isLimitedAccess: false,
				titleMessageId: "ktx.dse.title"
			}
		],
		"ktx|cardiology_ekg": [
			{
				id: "ktx_ekg",
				isLimitedAccess: false,
				titleMessageId: "ktx.ekg.title"
			}
		],
		"ktx|cardiology_hearth_mri": [
			{
				id: "ktx_hearthMri",
				isLimitedAccess: false,
				titleMessageId: "ktx.hearth_mri.title"
			}
		],
		"ktx|cardiology_opinion": [
			{
				id: "ktx_cardiologyOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.cardiology_opinion.title"
			}
		],
		"ktx|cardiology_spect": [
			{
				id: "ktx_spect",
				isLimitedAccess: false,
				titleMessageId: "ktx.spect.title"
			}
		],
		"ktx|cardiology_transtorachalis_echo": [
			{
				id: "ktx_transtorachalisEcho",
				isLimitedAccess: false,
				titleMessageId: "ktx.transtorachalis_echo.title"
			}
		],
		"ktx|cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|cardiovascular_disease_type": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|carotis_doppler": [
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			}
		],
		"ktx|cause_of_graftloss": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|cerebral_sinus_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|cerebrum_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|cervix_uteri_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|chest_ct": [
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			}
		],
		"ktx|chest_x_ray": [
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			}
		],
		"ktx|cholecysta_pancreas_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|cholecystectomia_LC": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|chronic_rejection": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|chronic_renal_failure": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|coid_vaccination_COVAX-19": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|colonoscopy": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			}
		],
		"ktx|combined_organ_transplantation": [
			{
				id: "ktx_combinedOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.combined_organ_transplantation.title"
			}
		],
		"ktx|comment_for_blood_group": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|committee_opinion_statement": [
			{
				id: "ktx_committeeOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.committee_opinion"
			}
		],
		"ktx|congenital_renal_dysplasia": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|connective_tissue_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|consultation procedure": [
			{
				id: "ktx_cardiologyOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.cardiology_opinion.title"
			},
			{
				id: "ktx_diabetology",
				isLimitedAccess: false,
				titleMessageId: "ktx.diabetology.title"
			},
			{
				id: "ktx_endocrinology",
				isLimitedAccess: false,
				titleMessageId: "ktx.endocrinology.title"
			},
			{
				id: "ktx_gastroenterology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gastroenterology.title"
			},
			{
				id: "ktx_genetics",
				isLimitedAccess: false,
				titleMessageId: "ktx.genetics.title"
			},
			{
				id: "ktx_hematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hematology.title"
			},
			{
				id: "ktx_hepatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hepatology.title"
			},
			{
				id: "ktx_immunology",
				isLimitedAccess: false,
				titleMessageId: "ktx.immunology.title"
			},
			{
				id: "ktx_neurology",
				isLimitedAccess: false,
				titleMessageId: "ktx.neurology.title"
			},
			{
				id: "ktx_oncology",
				isLimitedAccess: false,
				titleMessageId: "ktx.oncology.title"
			},
			{
				id: "ktx_psychiatry",
				isLimitedAccess: false,
				titleMessageId: "ktx.psychiatry.title"
			},
			{
				id: "ktx_pulmonology",
				isLimitedAccess: false,
				titleMessageId: "ktx.pulmonology.title"
			},
			{
				id: "ktx_transplantAnesthesiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantAnesthesiology.title"
			},
			{
				id: "ktx_transplantNephrology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantNephrology.title"
			},
			{
				id: "ktx_transplantSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantSurgery.title"
			},
			{
				id: "ktx_vascularSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.vascularSurgery.title"
			}
		],
		"ktx|coronary_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|corpus_uteri_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|covid_disease": [
			{
				id: "ktx_covidDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_disease.title"
			}
		],
		"ktx|covid_vaccination": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Abdala": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_COVIran_Barekat": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Chinese_Academy_of_Medical_Sciences": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_CoVLP": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Convidecia": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Corbevax": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_CoronaVac": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Covaxin": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_CoviVac": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_EpiVacCorona": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Evusheld": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_FAKHRAVAC": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Janssen": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Medigen": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Minhai": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Moderna": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Noora": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Novavax": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Oxford–AstraZeneca": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Pfizer–BioNTech": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_QazCovid-in": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Razi_Cov_Pars": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_SKYCovione": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sinopharm": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sinopharm_NVSI": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sinopharm_WIBP": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Soberana_02": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Soberana_Plus": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sputnik": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Sputnik_Light": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Turkovac": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_VLA2001": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_Zifivax": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_ZyCoV-D6": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_no": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_type": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|covid_vaccination_unknown": [
			{
				id: "ktx_covidVaccination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.covid_vaccination.title"
			}
		],
		"ktx|cranium_CT_MR_angiography": [
			{
				id: "ktx_craniumCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.cranium_ct_mr_angiography.title"
			}
		],
		"ktx|crescentic": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cryoglobulinaemic_glomerulonephritis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cystic_kidney_disease_other_specified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cystic_kidney_disease_unspecified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|cystinosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|de_novo_kidney_disease": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|death_with_functioning_graft": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|dementia": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|dense_deposit_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|dental_screening": [
			{
				id: "ktx_dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.dentalScreening.title"
			}
		],
		"ktx|dermatology": [
			{
				id: "ktx_dermatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.dermatology.title"
			}
		],
		"ktx|description_of_patient_condition": [
			{
				id: "ktx_committeeOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.committee_opinion"
			}
		],
		"ktx|diabetes": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|diabetes_type_I": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|diabetes_type_II": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|diabetology": [
			{
				id: "ktx_diabetology",
				isLimitedAccess: false,
				titleMessageId: "ktx.diabetology.title"
			}
		],
		"ktx|dialatative_cardiomyopathy": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|drug_induced_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|drug_type": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_OAC_NOAC": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_acei": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_acethylsalicilate": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_amiodarone": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_amlodipine_dhp": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_arb": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_beta_receptor inhibitor": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_calcium_contain_phospphate_binders": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_clopidogrel": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_diuretics": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_erythropoetin_product": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_nonDHP": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_other": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_other_TAGs_thrombocyte_aggregation_inhibitors": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|drug_type_vitamine_D_product": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|ear_nose_throat": [
			{
				id: "ktx_earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "ktx.earNoseThroat.title"
			}
		],
		"ktx|endocrinology": [
			{
				id: "ktx_endocrinology",
				isLimitedAccess: false,
				titleMessageId: "ktx.endocrinology.title"
			}
		],
		"ktx|eyes_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|fabrys_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|focal_segmental_glomerulosclerosis_in_adults": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|focal_segmental_glomerulosclerosis_in_children": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|food_allergy": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_gluten": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_lactose": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_no": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|food_allergy_other": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|gastroenterology": [
			{
				id: "ktx_gastroenterology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gastroenterology.title"
			}
		],
		"ktx|genetics": [
			{
				id: "ktx_genetics",
				isLimitedAccess: false,
				titleMessageId: "ktx.genetics.title"
			}
		],
		"ktx|glandula_salivaris_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|glandula_thyroida_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|glomerulonephritis_histologically_examined": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|glomerulonephritis_histologically_not_examined": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|glomerulonephritis_related_to_liver_cirrhosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|goodpastures_syndrome": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|gout": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|graft_infection": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|graftectomy": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|graftectomy_ld": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|graftectomy_ls": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|graftloss_statement": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|gynecology": [
			{
				id: "ktx_gynecology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gynecology.title"
			}
		],
		"ktx|haemolytic_uraemic_syndrome": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|haemorrhagic_stroke": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|haemostaseology": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|haemostaseology_type": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|haemostaseology_type_other": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|has_cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|has_cardiovascular_disease_choice": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|has_graftloss": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|has_graftloss_choice": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|has_haemostaseology_disease": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|has_haemostaseology_disease_choice": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|has_metabolic_disease": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|has_metabolic_disease_choice": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|has_nephrectomy_graftectomy_disease": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|has_nephrectomy_graftectomy_disease_choice": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|has_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|has_oncology_disease_choice": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|has_other_disorder_disease": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|has_other_disorder_disease_choice": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|has_other_surgical_intervention": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|has_other_surgical_intervention_choice": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|has_previous_other_organ_transplantation": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|has_previous_other_organ_transplantation_choice": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|has_renal_anaemia_hepatology_disease": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|has_renal_anaemia_hepatology_disease_choice": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|hbv_chronic_liver_failure_statement": [
			{
				id: "ktx_chronicLiverFailureHbv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hbv"
			}
		],
		"ktx|hcv_chronic_liver_failure_statement": [
			{
				id: "ktx_chronicLiverFailureHcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.chronic_liver_failure_hcv"
			}
		],
		"ktx|height": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"ktx|hematology": [
			{
				id: "ktx_hematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hematology.title"
			}
		],
		"ktx|henoch_Schoenlein_purpura": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hepatology": [
			{
				id: "ktx_hepatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hepatology.title"
			}
		],
		"ktx|hepatology_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|hepatology_no_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|hereditary_Familial_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hereditary_nephritis_with_nerve_deafness": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hereditary_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|hernioplastica_inguinalis_ld": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|hernioplastica_inguinalis_ls": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|hernoplastica_par_abdominalis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|hodgkin_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|hyperthrophic_cardiomyopathy": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|hyperthyreosis": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|hypothyreosis": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|imaging_procedure": [
			{
				id: "ktx_abdominalCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_ct_mr_angiography.title"
			},
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			},
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			},
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			},
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			},
			{
				id: "ktx_craniumCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.cranium_ct_mr_angiography.title"
			},
			{
				id: "ktx_lowerLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.lower_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_nativeAbdominalXRay",
				isLimitedAccess: false,
				titleMessageId: "ktx.nativeAbdominalXRay.title"
			},
			{
				id: "ktx_neckCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.neck_ct_mr_angiography.title"
			},
			{
				id: "ktx_otherImagingProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.other_imaging_procedure.title"
			},
			{
				id: "ktx_upperLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_upperLimbDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_doppler.title"
			}
		],
		"ktx|immunology": [
			{
				id: "ktx_immunology",
				isLimitedAccess: false,
				titleMessageId: "ktx.immunology.title"
			}
		],
		"ktx|interstitial_nephritis_not_pyelonephritis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|ischaemic_renal_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|kaposi_sarcoma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|kidney_biopsy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|kidney_disease_ethiology": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|kidney_transplant": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|kidney_tumour": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|lab_CRP": [
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			}
		],
		"ktx|lab_HbA1c_calculated": [
			{
				id: "ktx_hgbA1CCalculated",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1CCalculated.title"
			}
		],
		"ktx|lab_HgbA1C": [
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			}
		],
		"ktx|lab_LDL_cholesterol": [
			{
				id: "ktx_ldlCholesterol",
				isLimitedAccess: false,
				titleMessageId: "ktx.ldlCholesterol.title"
			}
		],
		"ktx|lab_PSA": [
			{
				id: "ktx_psa",
				isLimitedAccess: false,
				titleMessageId: "ktx.psa.title"
			}
		],
		"ktx|lab_T3": [
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			}
		],
		"ktx|lab_T4": [
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			}
		],
		"ktx|lab_TSH": [
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			}
		],
		"ktx|lab_albumin": [
			{
				id: "ktx_albumin",
				isLimitedAccess: false,
				titleMessageId: "ktx.albumin.title"
			}
		],
		"ktx|lab_alkaline_phosphatase": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			}
		],
		"ktx|lab_bilirubin_direct": [
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			}
		],
		"ktx|lab_bilirubin_total": [
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			}
		],
		"ktx|lab_calcium": [
			{
				id: "ktx_calcium",
				isLimitedAccess: false,
				titleMessageId: "ktx.calcium.title"
			}
		],
		"ktx|lab_combined_kidney_pancreas": [
			{
				id: "ktx_combinedKidneyPancreas",
				isLimitedAccess: false,
				titleMessageId: "ktx.combinedKidneyPancreas.title"
			}
		],
		"ktx|lab_creatinine": [
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			}
		],
		"ktx|lab_eGFR": [
			{
				id: "ktx_eGfr",
				isLimitedAccess: false,
				titleMessageId: "ktx.eGfr.title"
			}
		],
		"ktx|lab_fasting_glucose": [
			{
				id: "ktx_fastingGlucose",
				isLimitedAccess: false,
				titleMessageId: "ktx.fastingGlucose.title"
			}
		],
		"ktx|lab_ferritine": [
			{
				id: "ktx_ferritine",
				isLimitedAccess: false,
				titleMessageId: "ktx.ferritine.title"
			}
		],
		"ktx|lab_ggt": [
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			}
		],
		"ktx|lab_got": [
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			}
		],
		"ktx|lab_gpt": [
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			}
		],
		"ktx|lab_haemoglobin": [
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			}
		],
		"ktx|lab_iPTH": [
			{
				id: "ktx_iPth",
				isLimitedAccess: false,
				titleMessageId: "ktx.iPth.title"
			}
		],
		"ktx|lab_inr": [
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			}
		],
		"ktx|lab_other_procedure": [
			{
				id: "ktx_otherLabProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.otherLabProcedure.title"
			}
		],
		"ktx|lab_phosphate": [
			{
				id: "ktx_phosphate",
				isLimitedAccess: false,
				titleMessageId: "ktx.phosphate.title"
			}
		],
		"ktx|lab_potassium": [
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			}
		],
		"ktx|lab_procedure": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			},
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			},
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			},
			{
				id: "ktx_calcium",
				isLimitedAccess: false,
				titleMessageId: "ktx.calcium.title"
			},
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			},
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			},
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			},
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			},
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			},
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			},
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			},
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			},
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			},
			{
				id: "ktx_phosphate",
				isLimitedAccess: false,
				titleMessageId: "ktx.phosphate.title"
			},
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			},
			{
				id: "ktx_psa",
				isLimitedAccess: false,
				titleMessageId: "ktx.psa.title"
			},
			{
				id: "ktx_stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolBlood.title"
			},
			{
				id: "ktx_stoolculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolculture.title"
			},
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			},
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			},
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			},
			{
				id: "ktx_urineculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineculture.title"
			},
			{
				id: "ktx_urineProteinCreatinineRatio",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineProteinCreatinineRatio.title"
			}
		],
		"ktx|lab_rest_diuresis": [
			{
				id: "ktx_restDiuresis",
				isLimitedAccess: false,
				titleMessageId: "ktx.restDiuresis.title"
			}
		],
		"ktx|lab_serum_iron": [
			{
				id: "ktx_serumIron",
				isLimitedAccess: false,
				titleMessageId: "ktx.serumIron.title"
			}
		],
		"ktx|lab_sodium": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			}
		],
		"ktx|lab_stool_blood": [
			{
				id: "ktx_stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolBlood.title"
			}
		],
		"ktx|lab_stool_culture": [
			{
				id: "ktx_stoolculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolculture.title"
			}
		],
		"ktx|lab_thrombocyte": [
			{
				id: "ktx_thrombocyte",
				isLimitedAccess: false,
				titleMessageId: "ktx.thrombocyte.title"
			}
		],
		"ktx|lab_total_cholesterol": [
			{
				id: "ktx_totalCholesterol",
				isLimitedAccess: false,
				titleMessageId: "ktx.totalCholesterol.title"
			}
		],
		"ktx|lab_total_iron_binding_capacity": [
			{
				id: "ktx_totalIronBindingCapacity",
				isLimitedAccess: false,
				titleMessageId: "ktx.totalIronBindingCapacity.title"
			}
		],
		"ktx|lab_total_protein": [
			{
				id: "ktx_totalProtein",
				isLimitedAccess: false,
				titleMessageId: "ktx.totalProtein.title"
			}
		],
		"ktx|lab_total_urine_analysis": [
			{
				id: "ktx_totalUrineAnalysis",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.total_urine_analysis.title"
			}
		],
		"ktx|lab_transferrin_saturation": [
			{
				id: "ktx_transferrinSaturation",
				isLimitedAccess: false,
				titleMessageId: "ktx.transferrinSaturation.title"
			}
		],
		"ktx|lab_triglyceride": [
			{
				id: "ktx_triglyceride",
				isLimitedAccess: false,
				titleMessageId: "ktx.triglyceride.title"
			}
		],
		"ktx|lab_urate": [
			{
				id: "ktx_urate",
				isLimitedAccess: false,
				titleMessageId: "ktx.urate.title"
			}
		],
		"ktx|lab_urea_nitrogen": [
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			}
		],
		"ktx|lab_urine_culture": [
			{
				id: "ktx_urineculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineculture.title"
			}
		],
		"ktx|lab_urine_protein_creatinine_ratio": [
			{
				id: "ktx_urineProteinCreatinineRatio",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineProteinCreatinineRatio.title"
			}
		],
		"ktx|lab_white_blood_cell_count": [
			{
				id: "ktx_whiteBloodCellCount",
				isLimitedAccess: false,
				titleMessageId: "ktx.whiteBloodCellCount.title"
			}
		],
		"ktx|lactose_intolerance": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|larynx_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|leukaemia_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|leukopaenia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|lipoprotein_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|lips_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|live_donor_screening": [
			{
				id: "ktx_liveDonorScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.live_donor_screening.title"
			}
		],
		"ktx|liver_failure": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|lower_limb_CT_MR_angiography": [
			{
				id: "ktx_lowerLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.lower_limb_ct_mr_angiography.title"
			}
		],
		"ktx|lower_limb_deep_vein_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|lung_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|lupus_erythematosus": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|macrocyter_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|macrovascular_consequence": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|malignant_disease_of_the_liver": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|mamma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|mammography": [
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			}
		],
		"ktx|medical_treatment_statement": [
			{
				id: "ktx_medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.medicalTreatment.title"
			}
		],
		"ktx|medicine_active_ingredient": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_diagnosis": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|medicine_sensitivity": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_NSAID": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_RASI": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_acethylsalicilate": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_amlodipine": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_beta_receptor_antagonists": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_cephalosporine": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_digitalis": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_fluorocinolone": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_no": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_other": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_penicillin": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_sulfametaxasole_thrometoprim": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medicine_sensitivity_vancomycin": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|medullary_cystic_disease": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|melanoma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|membrano_proliferative": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|membranous_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|mesothelioma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|metabolic_disease_type": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|metabolic_liver_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|microbiological_cmv": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			}
		],
		"ktx|microbiological_ebv": [
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			}
		],
		"ktx|microbiological_hbv_status": [
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			}
		],
		"ktx|microbiological_hcv": [
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			}
		],
		"ktx|microbiological_hiv": [
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			}
		],
		"ktx|microbiological_procedure": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			},
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			},
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			},
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			},
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			},
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			},
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			},
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"ktx|microbiological_toxoplasma": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"ktx|microbiological_treponema_pallidum": [
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			}
		],
		"ktx|microbiological_varicella": [
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"ktx|microcyter_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|microvascular_consequence": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|miscellaneous": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			},
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|mitral_stenosis_or_insufficiency": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|mouth_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|multi_system_disease_other": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|multiple_myeloma_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|myelomatosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|native_abdominal_x-ray": [
			{
				id: "ktx_nativeAbdominalXRay",
				isLimitedAccess: false,
				titleMessageId: "ktx.nativeAbdominalXRay.title"
			}
		],
		"ktx|neck_CT_MR_angiography": [
			{
				id: "ktx_neckCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.neck_ct_mr_angiography.title"
			}
		],
		"ktx|neoplasms_of_bone_marrow_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|nephrectomy": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_graftectomy": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_ld": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_ls": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrectomy_lu": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|nephrocalcinosis_hypercalcaemic_nephropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|nephropathy_interstitial_due_to_analgesic_drugs": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|nephropathy_interstitial_due_to_cyclosporin_A": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|neurology": [
			{
				id: "ktx_neurology",
				isLimitedAccess: false,
				titleMessageId: "ktx.neurology.title"
			}
		],
		"ktx|no_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|no_unknown_cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|no_unknown_graftloss": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|no_unknown_haemostaseology_disease": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|no_unknown_metabolic_disease": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|no_unknown_nephrectomy_graftectomy_disease": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"ktx|no_unknown_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|no_unknown_other_disorder_disease": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|no_unknown_other_surgical_intervention": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|no_unknown_previous_other_organ_transplantation": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|no_unknown_renal_anaemia_hepatology_disease": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|non-complience": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|non_hodgkin_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|non_specific_graft_failure": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|nonalcoholic_fatty_liver_disease": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|normocyter_anaemia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|oesophagus_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|oligomeganephronic_hypoplasia": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|oncology": [
			{
				id: "ktx_oncology",
				isLimitedAccess: false,
				titleMessageId: "ktx.oncology.title"
			}
		],
		"ktx|oncology_disease_type": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|ophthalmology": [
			{
				id: "ktx_ophthalmology",
				isLimitedAccess: false,
				titleMessageId: "ktx.ophthalmology.title"
			}
		],
		"ktx|other_allergy": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|other_cardiovascular_disease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|other_cause": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|other_disorder": [
			{
				id: "ktx_otherDisorders",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.otherDisorders.title"
			}
		],
		"ktx|other_identified_renal_disorders": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|other_imaging_procedure": [
			{
				id: "ktx_otherImagingProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.other_imaging_procedure.title"
			}
		],
		"ktx|other_renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|other_surgical_intervention": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|other_surgical_intervention_other": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|other_surgical_intervention_type": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|ovarium_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|parathyreoidectomia_partialis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|parathyreoidectomia_totalis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|patient_assigned_user": [
			{
				id: "ktx_committeeOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.committee_opinion"
			}
		],
		"ktx|patient_et_id": [
			{
				id: "ktx_coordination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.coordination"
			}
		],
		"ktx|patient_status": [
			{
				id: "ktx_committeeOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.committee_opinion"
			}
		],
		"ktx|penis_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|peripheral_artery_diesease": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|pituitary_malfunction": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|polycystic_kidneys_adult_type": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|polycystic_kidneys_infantile": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|polyneuropathy": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|porphyrin_and_bilirubin_metabolic_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|postrenal_causes": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|pregnancies_and_children_statement": [
			{
				id: "ktx_pregnanciesAndChildren",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.pregnancies_and_children.title"
			}
		],
		"ktx|previous_other_organ_transplantation": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_other_organ_transplantation_statement": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_bone_marrow": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_heart": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_kidney": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_liver": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_lung": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_other": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|previous_transplantation_pancreas": [
			{
				id: "ktx_previousOtherOrganTransplantation",
				isLimitedAccess: false,
				titleMessageId:
					"ktx.form.previous_other_organ_transplantation.title"
			}
		],
		"ktx|primary_hypertension": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|primary_non_function": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|primary_oxalosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|primary_renal_disease": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|prostata_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|psychiatry": [
			{
				id: "ktx_psychiatry",
				isLimitedAccess: false,
				titleMessageId: "ktx.psychiatry.title"
			}
		],
		"ktx|pulmonary_embolism": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|pulmonology": [
			{
				id: "ktx_pulmonology",
				isLimitedAccess: false,
				titleMessageId: "ktx.pulmonology.title"
			}
		],
		"ktx|purine_and_pirimidine_metabolic_disturbances": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|pyelonephritis_associated_with_neurogenic_bladder": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_cause_not_specified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_acquired_obstructive_uropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_congenital_obstructive_uropathy": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_other_cause": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_urolithiasis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|pyelonephritis_due_to_vesico-ureteric_reflux_without_obstruction":
			[
				{
					id: "ktx_kidneyDiseaseEthiology",
					isLimitedAccess: false,
					titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
				}
			],
		"ktx|renal_anaemia_hematology_statement": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|renal_anaemia_hematology_type": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|renal_hypoplasia_congenital": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_malignancy_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|renal_replacement_therapy": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|renal_replacement_therapy_statement": [
			{
				id: "ktx_renalReplacementTherapy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_replacement_therapy.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_hypertension": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_malignant_hypertension": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_other_cause": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_due_to_polyarteritis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|renal_vascular_disease_type_unspecified": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|rh": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"ktx|secondary_hypertension": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|sensitivities_and_allergies_statement": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"ktx|signed_statement_of_consent_fyrms": [
			{
				id: "ktx_patientStatementOfConsentFyrms",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.patient_statement_of_consent_fyrms"
			}
		],
		"ktx|signed_statement_of_consent_ovsz": [
			{
				id: "ktx_patientStatementOfConsentOvsz",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.patient_statement_of_consent_ovsz"
			}
		],
		"ktx|skin_tumour_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|small_intestine_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|smoking_cigarettes_pack_years": [
			{
				id: "ktx_smoking",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.smoking"
			}
		],
		"ktx|smoking_statement": [
			{
				id: "ktx_smoking",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.smoking"
			}
		],
		"ktx|sphyngolipid_and_glucosaminoglycane": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|stenosis_arteriae_conorariae": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|stenosis_arteriae_renalis": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"ktx|superficial_vein_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|syndrome_of_agenesis_of_abdominal_muscles": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|systemic_sclerosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|testis_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|thrombopaenia": [
			{
				id: "ktx_renalAnaemiaHematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.renal_anaemia_hematology.title"
			}
		],
		"ktx|thrombosis_neck_region": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|thymus_disorder": [
			{
				id: "ktx_metabolicDisease",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.metabolicDisease.title"
			}
		],
		"ktx|thyreoidectomia_partialis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|thyreoidectomia_totalis": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|tonsillectomia": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|toung_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|trachea_bronchus_bronchii_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|transfusion": [
			{
				id: "ktx_transfusion",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.transfusion.title"
			}
		],
		"ktx|transplant_anesthesiology": [
			{
				id: "ktx_transplantAnesthesiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantAnesthesiology.title"
			}
		],
		"ktx|transplant_nephrology": [
			{
				id: "ktx_transplantNephrology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantNephrology.title"
			}
		],
		"ktx|transplant_surgery": [
			{
				id: "ktx_transplantSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantSurgery.title"
			}
		],
		"ktx|traumatic_or_surgical_loss_of_kidney": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|tuberculosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|tubular_necrosis_irreversible": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|tumour_research": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			},
			{
				id: "ktx_dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.dentalScreening.title"
			},
			{
				id: "ktx_dermatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.dermatology.title"
			},
			{
				id: "ktx_earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "ktx.earNoseThroat.title"
			},
			{
				id: "ktx_gynecology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gynecology.title"
			},
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			},
			{
				id: "ktx_ophthalmology",
				isLimitedAccess: false,
				titleMessageId: "ktx.ophthalmology.title"
			},
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"ktx|turp": [
			{
				id: "ktx_otherSurgicalIntervention",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.other_surgical_intervention"
			}
		],
		"ktx|unknown_cause": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|upper_limb_CT_MR_angiography": [
			{
				id: "ktx_upperLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_ct_mr_angiography.title"
			}
		],
		"ktx|upper_limb_deep_vein_thrombosis": [
			{
				id: "ktx_haemostaseology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.haemostaseology.title"
			}
		],
		"ktx|upper_limb_doppler": [
			{
				id: "ktx_upperLimbDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_doppler.title"
			}
		],
		"ktx|ureteral_malignancy_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|urethra_malignancy_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|urology": [
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"ktx|vascular_diseases_of_the_liver": [
			{
				id: "ktx_hepatologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.hepatologyDiseases"
			}
		],
		"ktx|vascular_problems": [
			{
				id: "ktx_graftloss",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.graftloss.title"
			}
		],
		"ktx|vascular_surgery": [
			{
				id: "ktx_vascularSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.vascularSurgery.title"
			}
		],
		"ktx|ventriculus_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|vulva_oncology_disease": [
			{
				id: "ktx_oncologyDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.oncologyDisease.title"
			}
		],
		"ktx|waiting_list_start_date": [
			{
				id: "ktx_coordination",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.coordination"
			}
		],
		"ktx|wegeners_granulomatosis": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"ktx|weight": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|10331-7": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"loinc|14631-6": [
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			}
		],
		"loinc|14920-3": [
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			}
		],
		"loinc|14928-6": [
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			}
		],
		"loinc|14937-7": [
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			}
		],
		"loinc|1742-6": [
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			}
		],
		"loinc|1751-7": [
			{
				id: "ktx_albumin",
				isLimitedAccess: false,
				titleMessageId: "ktx.albumin.title"
			}
		],
		"loinc|18746-8": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			}
		],
		"loinc|1920-8": [
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			}
		],
		"loinc|1988-5": [
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			}
		],
		"loinc|20464-4": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"loinc|2160-0": [
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			}
		],
		"loinc|22580-5": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"loinc|2324-2": [
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			}
		],
		"loinc|24616-5": [
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			}
		],
		"loinc|25020": [
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			}
		],
		"loinc|29463-7": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|2947-0": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			}
		],
		"loinc|3140-1": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|34530-6": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"loinc|34714-6": [
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			}
		],
		"loinc|34851-6": [
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"loinc|36572-6": [
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			}
		],
		"loinc|39156-5": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|407367": [
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			}
		],
		"loinc|6298-4": [
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			}
		],
		"loinc|6768-6": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			}
		],
		"loinc|718-7": [
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			}
		],
		"loinc|8302-2": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"loinc|86910-7": [
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			}
		],
		"loinc|883-9": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"loinc|94141-9": [
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			}
		],
		"snomed|104305007": [
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			}
		],
		"snomed|104326007": [
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"snomed|105011006": [
			{
				id: "ktx_karbamid",
				isLimitedAccess: false,
				titleMessageId: "ktx.karbamid.title"
			}
		],
		"snomed|1119418001": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"snomed|112143006": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"snomed|113075003": [
			{
				id: "ktx_creatinine",
				isLimitedAccess: false,
				titleMessageId: "ktx.creatinine.title"
			}
		],
		"snomed|117010004": [
			{
				id: "ktx_urineculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineculture.title"
			}
		],
		"snomed|117028002": [
			{
				id: "ktx_stoolculture",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolculture.title"
			}
		],
		"snomed|128178001": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|129714008": [
			{
				id: "ktx_mammography",
				isLimitedAccess: false,
				titleMessageId: "ktx.mammography.title"
			}
		],
		"snomed|165994006": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			},
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			},
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			},
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			},
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			},
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			},
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			},
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			}
		],
		"snomed|166324000": [
			{
				id: "ktx_t3",
				isLimitedAccess: false,
				titleMessageId: "ktx.t3.title"
			}
		],
		"snomed|166329005": [
			{
				id: "ktx_t4",
				isLimitedAccess: false,
				titleMessageId: "ktx.t4.title"
			}
		],
		"snomed|166704001": [
			{
				id: "ktx_phosphate",
				isLimitedAccess: false,
				titleMessageId: "ktx.phosphate.title"
			}
		],
		"snomed|169069000": [
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			}
		],
		"snomed|170865004": [
			{
				id: "ktx_gynecology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gynecology.title"
			}
		],
		"snomed|170945005": [
			{
				id: "ktx_ophthalmology",
				isLimitedAccess: false,
				titleMessageId: "ktx.ophthalmology.title"
			}
		],
		"snomed|171121004": [
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			}
		],
		"snomed|187033005": [
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			}
		],
		"snomed|1951000175101": [
			{
				id: "ktx_inr",
				isLimitedAccess: false,
				titleMessageId: "ktx.inr.title"
			}
		],
		"snomed|20135006": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			},
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			},
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			},
			{
				id: "ktx_hcv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hcv.title"
			},
			{
				id: "ktx_hiv",
				isLimitedAccess: false,
				titleMessageId: "ktx.hiv.title"
			},
			{
				id: "ktx_toxoplasma",
				isLimitedAccess: false,
				titleMessageId: "ktx.toxoplasma.title"
			},
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			},
			{
				id: "ktx_varicella",
				isLimitedAccess: false,
				titleMessageId: "ktx.varicella.title"
			},
			{
				id: "ktx_abdominalCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_ct_mr_angiography.title"
			},
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			},
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			},
			{
				id: "ktx_chestCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_ct_mr_angiography.title"
			},
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			},
			{
				id: "ktx_craniumCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.cranium_ct_mr_angiography.title"
			},
			{
				id: "ktx_lowerLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.lower_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_nativeAbdominalXRay",
				isLimitedAccess: false,
				titleMessageId: "ktx.nativeAbdominalXRay.title"
			},
			{
				id: "ktx_neckCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.neck_ct_mr_angiography.title"
			},
			{
				id: "ktx_otherImagingProcedure",
				isLimitedAccess: false,
				titleMessageId: "ktx.other_imaging_procedure.title"
			},
			{
				id: "ktx_upperLimbCtMrAngiography",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_ct_mr_angiography.title"
			},
			{
				id: "ktx_upperLimbDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.upper_limb_doppler.title"
			}
		],
		"snomed|224238005": [
			{
				id: "ktx_committeeOpinion",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.committee_opinion"
			}
		],
		"snomed|23901000087101": [
			{
				id: "ktx_hepatology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hepatology.title"
			}
		],
		"snomed|2425002": [
			{
				id: "ktx_ebv",
				isLimitedAccess: false,
				titleMessageId: "ktx.ebv.title"
			}
		],
		"snomed|252407006": [
			{
				id: "ktx_treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "ktx.treponemaPallidum.title"
			}
		],
		"snomed|265550007": [
			{
				id: "ktx_nephrectomyOrGraftectomy",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.nephrectomy_or_graftectomy"
			}
		],
		"snomed|26758005": [
			{
				id: "ktx_albumin",
				isLimitedAccess: false,
				titleMessageId: "ktx.albumin.title"
			}
		],
		"snomed|271240001": [
			{
				id: "ktx_calcium",
				isLimitedAccess: false,
				titleMessageId: "ktx.calcium.title"
			}
		],
		"snomed|30200007": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			}
		],
		"snomed|305634004": [
			{
				id: "ktx_transplantAnesthesiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.transplantAnesthesiology.title"
			}
		],
		"snomed|305635003": [
			{
				id: "ktx_oncology",
				isLimitedAccess: false,
				titleMessageId: "ktx.oncology.title"
			}
		],
		"snomed|305657005": [
			{
				id: "ktx_hematology",
				isLimitedAccess: false,
				titleMessageId: "ktx.hematology.title"
			}
		],
		"snomed|305671002": [
			{
				id: "ktx_endocrinology",
				isLimitedAccess: false,
				titleMessageId: "ktx.endocrinology.title"
			}
		],
		"snomed|305672009": [
			{
				id: "ktx_gastroenterology",
				isLimitedAccess: false,
				titleMessageId: "ktx.gastroenterology.title"
			}
		],
		"snomed|305674005": [
			{
				id: "ktx_genetics",
				isLimitedAccess: false,
				titleMessageId: "ktx.genetics.title"
			}
		],
		"snomed|305710003": [
			{
				id: "ktx_earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "ktx.earNoseThroat.title"
			}
		],
		"snomed|305729009": [
			{
				id: "ktx_urology",
				isLimitedAccess: false,
				titleMessageId: "ktx.urology.title"
			}
		],
		"snomed|305730004": [
			{
				id: "ktx_vascularSurgery",
				isLimitedAccess: false,
				titleMessageId: "ktx.vascularSurgery.title"
			}
		],
		"snomed|312468003": [
			{
				id: "ktx_potassium",
				isLimitedAccess: false,
				titleMessageId: "ktx.potassium.title"
			}
		],
		"snomed|312469006": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "ktx.natrium.title"
			}
		],
		"snomed|313500004": [
			{
				id: "ktx_urineProteinCreatinineRatio",
				isLimitedAccess: false,
				titleMessageId: "ktx.urineProteinCreatinineRatio.title"
			}
		],
		"snomed|313604004": [
			{
				id: "ktx_cmv",
				isLimitedAccess: false,
				titleMessageId: "ktx.cmv.title"
			}
		],
		"snomed|34043003": [
			{
				id: "ktx_dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "ktx.dentalScreening.title"
			}
		],
		"snomed|34608000": [
			{
				id: "ktx_sgpt",
				isLimitedAccess: false,
				titleMessageId: "ktx.gpt.title"
			}
		],
		"snomed|359986008": [
			{
				id: "ktx_bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinTotal.title"
			}
		],
		"snomed|363783003": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"snomed|363808001": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|365636006": [
			{
				id: "ktx_bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.blood_group"
			}
		],
		"snomed|365809007": [
			{
				id: "ktx_haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "ktx.haemoglobin.title"
			}
		],
		"snomed|390842003": [
			{
				id: "ktx_diabetology",
				isLimitedAccess: false,
				titleMessageId: "ktx.diabetology.title"
			}
		],
		"snomed|394719009": [
			{
				id: "ktx_carotisDoppler",
				isLimitedAccess: false,
				titleMessageId: "ktx.carotisDoppler.title"
			}
		],
		"snomed|39748002": [
			{
				id: "ktx_bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "ktx.bilirubinDirect.title"
			}
		],
		"snomed|399208008": [
			{
				id: "ktx_chestXray",
				isLimitedAccess: false,
				titleMessageId: "ktx.chest_xray.title"
			}
		],
		"snomed|414285001": [
			{
				id: "ktx_allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.allergies_and_sensitivities.title"
			}
		],
		"snomed|43396009": [
			{
				id: "ktx_hgbA1CIfcc",
				isLimitedAccess: false,
				titleMessageId: "ktx.hgbA1C.title"
			}
		],
		"snomed|442516004": [
			{
				id: "ktx_stoolBlood",
				isLimitedAccess: false,
				titleMessageId: "ktx.stoolBlood.title"
			}
		],
		"snomed|444562008": [
			{
				id: "ktx_pulmonology",
				isLimitedAccess: false,
				titleMessageId: "ktx.pulmonology.title"
			}
		],
		"snomed|45036003": [
			{
				id: "ktx_abdominalPelvisUltrasound",
				isLimitedAccess: false,
				titleMessageId: "ktx.abdominal_pelvis_ultrasound.title"
			}
		],
		"snomed|45896001": [
			{
				id: "ktx_sgot",
				isLimitedAccess: false,
				titleMessageId: "ktx.got.title"
			}
		],
		"snomed|49601007": [
			{
				id: "ktx_cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.cardiovascularDiseases.title"
			}
		],
		"snomed|50373000": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|55235003": [
			{
				id: "ktx_hsCrp",
				isLimitedAccess: false,
				titleMessageId: "ktx.crp.title"
			}
		],
		"snomed|60621009": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"snomed|61167004": [
			{
				id: "ktx_tsh",
				isLimitedAccess: false,
				titleMessageId: "ktx.tsh.title"
			}
		],
		"snomed|62889000": [
			{
				id: "ktx_hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "ktx.hbvStatus.title"
			}
		],
		"snomed|63476009": [
			{
				id: "ktx_psa",
				isLimitedAccess: false,
				titleMessageId: "ktx.psa.title"
			}
		],
		"snomed|69480007": [
			{
				id: "ktx_ggt",
				isLimitedAccess: false,
				titleMessageId: "ktx.ggt.title"
			}
		],
		"snomed|7246002": [
			{
				id: "ktx_kidneyDiseaseEthiology",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.kidneyDiseaseEthiology.title"
			}
		],
		"snomed|73761001": [
			{
				id: "ktx_colonoscopy",
				isLimitedAccess: false,
				titleMessageId: "ktx.colonoscopy.title"
			}
		],
		"snomed|74732009": [
			{
				id: "ktx_psychiatry",
				isLimitedAccess: false,
				titleMessageId: "ktx.psychiatry.title"
			}
		],
		"snomed|88810008": [
			{
				id: "ktx_alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "ktx.alkalinePhosphatase.title"
			}
		],
		"srtr|can_hgt_cm": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		],
		"srtr|can_most_recent_wgt_kg7": [
			{
				id: "ktx_anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.anthropometrics"
			}
		]
	},
	ltx: {
		"loinc|10331-7": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|11154-2": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"loinc|13946-9": [
			{
				id: "coombsDirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_direct"
			},
			{
				id: "coombsIndirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_indirect"
			}
		],
		"loinc|14338-8": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"loinc|14631-6": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"loinc|14920-3": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"loinc|14928-6": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"loinc|14937-7": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"loinc|16954-0": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"loinc|1742-6": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"loinc|1751-7": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "albumin",
				isLimitedAccess: false,
				titleMessageId: "form.albumin"
			}
		],
		"loinc|19162-7": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"loinc|1920-8": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"loinc|1988-5": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"loinc|20464-4": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"loinc|2160-0": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"loinc|22244-8": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"loinc|22322-2": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"loinc|22580-5": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"loinc|2324-2": [
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			},
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"loinc|24325-3": [
			{
				id: "ama",
				isLimitedAccess: false,
				titleMessageId: "form.ama"
			},
			{
				id: "ana",
				isLimitedAccess: false,
				titleMessageId: "form.ana"
			},
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			},
			{
				id: "cryoglobulin",
				isLimitedAccess: false,
				titleMessageId: "form.cryoglobulin"
			},
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			},
			{
				id: "lkm",
				isLimitedAccess: false,
				titleMessageId: "form.lkm"
			},
			{
				id: "pAnca",
				isLimitedAccess: false,
				titleMessageId: "form.panca"
			},
			{
				id: "sma",
				isLimitedAccess: false,
				titleMessageId: "form.sma"
			},
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"loinc|24362-6": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"loinc|25020": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"loinc|2532-0": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"loinc|26515-7": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"loinc|29463-7": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|2947-0": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"loinc|31204-1": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"loinc|3140-1": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|32685-0": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"loinc|33762-6": [
			{
				id: "bnp",
				isLimitedAccess: false,
				titleMessageId: "form.bnp"
			},
			{
				id: "ntProBNP",
				isLimitedAccess: false,
				titleMessageId: "form.nt_pro_bnp"
			}
		],
		"loinc|33914-3": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"loinc|34530-6": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"loinc|34714-6": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"loinc|34851-6": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"loinc|36572-6": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			},
			{
				id: "lumbarSpineXRay",
				isLimitedAccess: false,
				titleMessageId: "form.lumbar_spine_x_ray"
			}
		],
		"loinc|39156-5": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|39480-9": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"loinc|407367": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"loinc|43111-4": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"loinc|49178-7": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"loinc|5195-3": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"loinc|53764-7": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"loinc|5418-8": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|55112-7": [
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"loinc|55429-5": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"loinc|6298-4": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"loinc|6690-2": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"loinc|6768-6": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"loinc|718-7": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"loinc|8302-2": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"loinc|86910-7": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"loinc|883-9": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"ltx|BNP": [
			{
				id: "bnp",
				isLimitedAccess: false,
				titleMessageId: "form.bnp"
			}
		],
		"ltx|CT_angiography_result": [
			{
				id: "ctAngiography",
				isLimitedAccess: false,
				titleMessageId: "form.ct_angiography"
			}
		],
		"ltx|CT_angiography_result_comment": [
			{
				id: "ctAngiography",
				isLimitedAccess: false,
				titleMessageId: "form.ct_angiography"
			}
		],
		"ltx|NT-proBNP": [
			{
				id: "ntProBNP",
				isLimitedAccess: false,
				titleMessageId: "form.nt_pro_bnp"
			}
		],
		"ltx|ab0": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"ltx|abdominal_circumference": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"ltx|abdominal_ct_result": [
			{
				id: "abdominalCt",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ct"
			}
		],
		"ltx|abdominal_ct_result_comment": [
			{
				id: "abdominalCt",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ct"
			}
		],
		"ltx|abdominal_doppler_ultrasound_result": [
			{
				id: "abdominalDopplerUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_doppler_ultrasound"
			}
		],
		"ltx|abdominal_doppler_ultrasound_result_comment": [
			{
				id: "abdominalDopplerUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_doppler_ultrasound"
			}
		],
		"ltx|abdominal_mri_result": [
			{
				id: "abdominalMri",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_mri"
			}
		],
		"ltx|abdominal_mri_result_comment": [
			{
				id: "abdominalMri",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_mri"
			}
		],
		"ltx|abdominal_ultrasound_result": [
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			}
		],
		"ltx|abdominal_ultrasound_result_comment": [
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			}
		],
		"ltx|addiction_assessment": [
			{
				id: "addictionAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.addiction_assessment"
			}
		],
		"ltx|alkaline_phosphatase": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"ltx|allergies": [
			{
				id: "allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "form.allergies_and_sensitivities"
			}
		],
		"ltx|allergies_and_sensitivities_form": [
			{
				id: "allergiesAndSensitivities",
				isLimitedAccess: false,
				titleMessageId: "form.allergies_and_sensitivities"
			}
		],
		"ltx|ama": [
			{
				id: "ama",
				isLimitedAccess: false,
				titleMessageId: "form.ama"
			}
		],
		"ltx|ana": [
			{
				id: "ana",
				isLimitedAccess: false,
				titleMessageId: "form.ana"
			}
		],
		"ltx|anesthesiology_result": [
			{
				id: "anesthesiology",
				isLimitedAccess: false,
				titleMessageId: "form.anesthesiology"
			}
		],
		"ltx|angiography_indirect_portography_result": [
			{
				id: "angiographyIndirectPortography",
				isLimitedAccess: false,
				titleMessageId: "form.angiography_indirect_portography"
			}
		],
		"ltx|angiography_indirect_portography_result_comment": [
			{
				id: "angiographyIndirectPortography",
				isLimitedAccess: false,
				titleMessageId: "form.angiography_indirect_portography"
			}
		],
		"ltx|anti_cardiolipin_at": [
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			}
		],
		"ltx|anti_cardiolipin_at_iga": [
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			}
		],
		"ltx|anti_cardiolipin_at_igg": [
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			}
		],
		"ltx|anti_cardiolipin_at_igm": [
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			}
		],
		"ltx|arterial_conduit_planned": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|arterial_pressure_monitoring_planned": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|arterial_supply": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|ascites_child_pugh": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|ascitic_fluid_culture_result": [
			{
				id: "asciticFluidCulture",
				isLimitedAccess: false,
				titleMessageId: "form.ascitic_fluid_culture"
			}
		],
		"ltx|ascitic_fluid_culture_result_comment": [
			{
				id: "asciticFluidCulture",
				isLimitedAccess: false,
				titleMessageId: "form.ascitic_fluid_culture"
			}
		],
		"ltx|backup_recipient": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|bilirubin_direct": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"ltx|bilirubin_total": [
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"ltx|blood_group": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"ltx|bmi": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"ltx|bone_scan": [
			{
				id: "boneScan",
				isLimitedAccess: false,
				titleMessageId: "form.bone_scan"
			}
		],
		"ltx|bone_scan_comment": [
			{
				id: "boneScan",
				isLimitedAccess: false,
				titleMessageId: "form.bone_scan"
			}
		],
		"ltx|bsa_dubois": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"ltx|bsa_monsteller": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"ltx|calculated_child_pugh_classification": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|cardiovascular_disease": [
			{
				id: "cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.cardiovascular_diseases"
			}
		],
		"ltx|cardiovascular_disease_comment": [
			{
				id: "cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.cardiovascular_diseases"
			}
		],
		"ltx|cardiovascular_disease_form": [
			{
				id: "cardiovascularDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.cardiovascular_diseases"
			}
		],
		"ltx|caudate_lobe": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|cell_saver_use_planned": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|chest_circumference": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"ltx|chest_ct_result": [
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			}
		],
		"ltx|chest_ct_result_comment": [
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			}
		],
		"ltx|chest_x_ray_result": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"ltx|chest_x_ray_result_comment": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			}
		],
		"ltx|child_pugh_classification": [
			{
				id: "childPughClassification",
				isLimitedAccess: false,
				titleMessageId: "form.childPughClassification"
			}
		],
		"ltx|child_pugh_score": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|cmv": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"ltx|cmv_igg": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"ltx|colitis_ulcerosa": [
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			}
		],
		"ltx|colitis_ulcerosa_activity": [
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			}
		],
		"ltx|colonoscopia": [
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			}
		],
		"ltx|colonoscopia_comment": [
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			}
		],
		"ltx|combined_transplant": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"ltx|comment_for_blood_group": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"ltx|coombs_direct": [
			{
				id: "coombsDirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_direct"
			}
		],
		"ltx|coombs_indirect": [
			{
				id: "coombsIndirect",
				isLimitedAccess: false,
				titleMessageId: "form.coombs_indirect"
			}
		],
		"ltx|cranium_ct_result": [
			{
				id: "craniumCt",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_ct"
			}
		],
		"ltx|cranium_ct_result_comment": [
			{
				id: "craniumCt",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_ct"
			}
		],
		"ltx|cranium_mr_result": [
			{
				id: "craniumMr",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_mr"
			}
		],
		"ltx|cranium_mr_result_comment": [
			{
				id: "craniumMr",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_mr"
			}
		],
		"ltx|creatinine": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"ltx|crohn_disease": [
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			}
		],
		"ltx|crohn_disease_activity": [
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			}
		],
		"ltx|crp": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"ltx|cryoglobulin": [
			{
				id: "cryoglobulin",
				isLimitedAccess: false,
				titleMessageId: "form.cryoglobulin"
			}
		],
		"ltx|dental_screening_result": [
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			}
		],
		"ltx|description_of_patient_condition": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			},
			{
				id: "patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"ltx|diabetes_mellitus_type": [
			{
				id: "endocrineDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.endocrine_diseases"
			}
		],
		"ltx|dialysis_at_least_twice_per_week": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|digital_rectal_exam_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"ltx|drug_type": [
			{
				id: "medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "form.medical_treatment"
			}
		],
		"ltx|ear_nose_throat": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"ltx|ebv_serology": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"ltx|ebv_serology_igg": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"ltx|encephalopathy": [
			{
				id: "encephalopathy",
				isLimitedAccess: false,
				titleMessageId: "form.encephalopathy"
			}
		],
		"ltx|encephalopathy_grade": [
			{
				id: "encephalopathy",
				isLimitedAccess: false,
				titleMessageId: "form.encephalopathy"
			}
		],
		"ltx|endocrine_disease": [
			{
				id: "endocrineDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.endocrine_diseases"
			}
		],
		"ltx|endocrine_disease_comment": [
			{
				id: "endocrineDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.endocrine_diseases"
			}
		],
		"ltx|endocrine_disease_form": [
			{
				id: "endocrineDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.endocrine_diseases"
			}
		],
		"ltx|ercp": [
			{
				id: "ercp",
				isLimitedAccess: false,
				titleMessageId: "form.ercp"
			}
		],
		"ltx|ercp_comment": [
			{
				id: "ercp",
				isLimitedAccess: false,
				titleMessageId: "form.ercp"
			}
		],
		"ltx|estimated_blood_loss": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|fibrosis_stage": [
			{
				id: "liverElastography",
				isLimitedAccess: false,
				titleMessageId: "form.liver_elastography"
			}
		],
		"ltx|forced_expiratory_volume_1_second": [
			{
				id: "pulmonaryFunctionTest",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonary_function_test"
			}
		],
		"ltx|forced_vital_capacity": [
			{
				id: "pulmonaryFunctionTest",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonary_function_test"
			}
		],
		"ltx|fvs": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"ltx|gastrointestinal_disease": [
			{
				id: "gastrointestinalDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.gastrointestinal_diseases"
			}
		],
		"ltx|gastrointestinal_disease_comment": [
			{
				id: "gastrointestinalDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.gastrointestinal_diseases"
			}
		],
		"ltx|gastrointestinal_disease_form": [
			{
				id: "gastrointestinalDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.gastrointestinal_diseases"
			}
		],
		"ltx|gastroscopia_result": [
			{
				id: "gastroscopia",
				isLimitedAccess: false,
				titleMessageId: "form.gastroscopia"
			}
		],
		"ltx|gastroscopia_result_comment": [
			{
				id: "gastroscopia",
				isLimitedAccess: false,
				titleMessageId: "form.gastroscopia"
			}
		],
		"ltx|gfr": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"ltx|ggt": [
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"ltx|got": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"ltx|gpt": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"ltx|green_light": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|gynecology_result": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"ltx|haemoglobin": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"ltx|hbc_ab_igg": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"ltx|hbc_ab_igm": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"ltx|hbs_ab": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"ltx|hbs_ag": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"ltx|hbv_status": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"ltx|height": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"ltx|helicobacter_pylori": [
			{
				id: "gastrointestinalDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.gastrointestinal_diseases"
			}
		],
		"ltx|hepa_c_virus_screening": [
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hcv"
			}
		],
		"ltx|hepatic_arterial_anatomy_type": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|hepatic_arterial_anatomy_type_comment": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|hepatorenal_syndrome": [
			{
				id: "hepatorenalSyndrome",
				isLimitedAccess: false,
				titleMessageId: "form.hepatorenalSyndrome"
			}
		],
		"ltx|hgb_a1_c": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"ltx|hiv_screening": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"ltx|hsv1_serology": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"ltx|hsv1_serology_igg": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"ltx|hsv2_serology": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"ltx|hsv2_serology_igg": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"ltx|hyper_immunised": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"ltx|immun_elfo": [
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			}
		],
		"ltx|immun_elfo_iga": [
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			}
		],
		"ltx|immun_elfo_igg": [
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			}
		],
		"ltx|immun_elfo_igm": [
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			}
		],
		"ltx|immunosuppression": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|immunosuppression_other": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|indication_for_liver_transplantation_comment": [
			{
				id: "indicationForLiverTransplantation",
				isLimitedAccess: false,
				titleMessageId: "form.indication_for_liver_transplantation"
			}
		],
		"ltx|indication_for_liver_transplantation_form": [
			{
				id: "indicationForLiverTransplantation",
				isLimitedAccess: false,
				titleMessageId: "form.indication_for_liver_transplantation"
			}
		],
		"ltx|inr": [
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"ltx|karbamid": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"ltx|ldh": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"ltx|liver_biopsy": [
			{
				id: "liverBiopsy",
				isLimitedAccess: false,
				titleMessageId: "form.liver_biopsy"
			}
		],
		"ltx|liver_biopsy_comment": [
			{
				id: "liverBiopsy",
				isLimitedAccess: false,
				titleMessageId: "form.liver_biopsy"
			}
		],
		"ltx|liver_elastography": [
			{
				id: "liverElastography",
				isLimitedAccess: false,
				titleMessageId: "form.liver_elastography"
			}
		],
		"ltx|liver_elastography_comment": [
			{
				id: "liverElastography",
				isLimitedAccess: false,
				titleMessageId: "form.liver_elastography"
			}
		],
		"ltx|liver_size": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|lkm": [
			{
				id: "lkm",
				isLimitedAccess: false,
				titleMessageId: "form.lkm"
			}
		],
		"ltx|lumbar_spine_x_ray_result": [
			{
				id: "lumbarSpineXRay",
				isLimitedAccess: false,
				titleMessageId: "form.lumbar_spine_x_ray"
			}
		],
		"ltx|lumbar_spine_x_ray_result_comment": [
			{
				id: "lumbarSpineXRay",
				isLimitedAccess: false,
				titleMessageId: "form.lumbar_spine_x_ray"
			}
		],
		"ltx|maximal_expiratory_flow_at_75": [
			{
				id: "pulmonaryFunctionTest",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonary_function_test"
			}
		],
		"ltx|medical_history_summary": [
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"ltx|medical_treatment": [
			{
				id: "medicalTreatment",
				isLimitedAccess: false,
				titleMessageId: "form.medical_treatment"
			}
		],
		"ltx|meld_na_score": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|meld_score": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|mrcp": [
			{
				id: "mrcp",
				isLimitedAccess: false,
				titleMessageId: "form.mrcp"
			}
		],
		"ltx|mrcp_comment": [
			{
				id: "mrcp",
				isLimitedAccess: false,
				titleMessageId: "form.mrcp"
			}
		],
		"ltx|nasal_swab_culture_result": [
			{
				id: "nasalSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.nasal_swab_culture"
			}
		],
		"ltx|nasal_swab_culture_result_comment": [
			{
				id: "nasalSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.nasal_swab_culture"
			}
		],
		"ltx|natrium": [
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"ltx|nephrological_urological_disease_comment": [
			{
				id: "nephrologicalAndUrologicalDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.nephrological_and_urological_diseases"
			}
		],
		"ltx|nephrological_urological_disease_form": [
			{
				id: "nephrologicalAndUrologicalDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.nephrological_and_urological_diseases"
			}
		],
		"ltx|neurology_result": [
			{
				id: "neurology",
				isLimitedAccess: false,
				titleMessageId: "form.neurology"
			}
		],
		"ltx|oncology": [
			{
				id: "oncology",
				isLimitedAccess: false,
				titleMessageId: "form.oncology"
			}
		],
		"ltx|oncology_comment": [
			{
				id: "oncology",
				isLimitedAccess: false,
				titleMessageId: "form.oncology"
			}
		],
		"ltx|ophthalmologic_examination_result": [
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			}
		],
		"ltx|other_consultation": [
			{
				id: "otherConsultations",
				isLimitedAccess: false,
				titleMessageId: "form.other_consultations"
			}
		],
		"ltx|other_consultation_comment": [
			{
				id: "otherConsultations",
				isLimitedAccess: false,
				titleMessageId: "form.other_consultations"
			}
		],
		"ltx|other_technical_difficulties": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|panca": [
			{
				id: "pAnca",
				isLimitedAccess: false,
				titleMessageId: "form.panca"
			}
		],
		"ltx|papanicolaou": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"ltx|patient_condition": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"ltx|patient_condition_report": [
			{
				id: "patientConditionReport",
				isLimitedAccess: false,
				titleMessageId: "form.patient_condition_report"
			}
		],
		"ltx|patient_et_id": [
			{
				id: "coordination",
				isLimitedAccess: false,
				titleMessageId: "form.coordination"
			}
		],
		"ltx|patient_status": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"ltx|peak_expiratory_flow": [
			{
				id: "pulmonaryFunctionTest",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonary_function_test"
			}
		],
		"ltx|platelet_count": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"ltx|portal_circulation": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|portal_vein_thrombosis_grade": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|portal_vein_thrombosis_grade_comment": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|potassium": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"ltx|prealbumin": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"ltx|pregnancies_and_children": [
			{
				id: "pregnanciesAndChildren",
				isLimitedAccess: false,
				titleMessageId: "form.pregnancies_and_children"
			}
		],
		"ltx|prostate_specific_antigen_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"ltx|psa": [
			{
				id: "psa",
				isLimitedAccess: false,
				titleMessageId: "form.psa"
			}
		],
		"ltx|pseudocholinesterase": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"ltx|psychiatric_assessment": [
			{
				id: "psychiatricAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatric_assessment"
			}
		],
		"ltx|psychological_assessment": [
			{
				id: "psychologicalAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.psychological_assessment"
			}
		],
		"ltx|psychological_assessment_comment": [
			{
				id: "psychologicalAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.psychological_assessment"
			}
		],
		"ltx|pulmonary_function_test": [
			{
				id: "pulmonaryFunctionTest",
				isLimitedAccess: false,
				titleMessageId: "form.pulmonary_function_test"
			}
		],
		"ltx|respiratory_pulmonary_disease": [
			{
				id: "respiratoryAndPulmonaryDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.respiratory_and_pulmonary_diseases"
			}
		],
		"ltx|respiratory_pulmonary_disease_comment": [
			{
				id: "respiratoryAndPulmonaryDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.respiratory_and_pulmonary_diseases"
			}
		],
		"ltx|respiratory_pulmonary_disease_form": [
			{
				id: "respiratoryAndPulmonaryDiseases",
				isLimitedAccess: false,
				titleMessageId: "form.respiratory_and_pulmonary_diseases"
			}
		],
		"ltx|rh": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"ltx|score_albumin": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|score_bilirubin_total": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|score_creatinine": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|score_encephalopathy_grade": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|score_inr": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|score_natrium": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			}
		],
		"ltx|serum_albumin": [
			{
				id: "albumin",
				isLimitedAccess: false,
				titleMessageId: "form.albumin"
			}
		],
		"ltx|serum_glucose": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"ltx|signed_statement_of_consent_timm": [
			{
				id: "ktx_patientStatementOfConsentTimm",
				isLimitedAccess: false,
				titleMessageId: "ktx.form.patient_statement_of_consent_timm"
			}
		],
		"ltx|sma": [
			{
				id: "sma",
				isLimitedAccess: false,
				titleMessageId: "form.sma"
			}
		],
		"ltx|splenic_artery_aneurysm": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|steatosis_grade": [
			{
				id: "liverElastography",
				isLimitedAccess: false,
				titleMessageId: "form.liver_elastography"
			}
		],
		"ltx|stool_culture_result": [
			{
				id: "stoolCulture",
				isLimitedAccess: false,
				titleMessageId: "form.stool_culture"
			}
		],
		"ltx|stool_culture_result_comment": [
			{
				id: "stoolCulture",
				isLimitedAccess: false,
				titleMessageId: "form.stool_culture"
			}
		],
		"ltx|surgical_procedure_type": [
			{
				id: "surgicalProcedures",
				isLimitedAccess: false,
				titleMessageId: "form.surgical_procedures"
			}
		],
		"ltx|surgical_procedures": [
			{
				id: "surgicalProcedures",
				isLimitedAccess: false,
				titleMessageId: "form.surgical_procedures"
			}
		],
		"ltx|t3": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"ltx|t4": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"ltx|throat_swab_culture_result": [
			{
				id: "throatSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.throat_swab_culture"
			}
		],
		"ltx|throat_swab_culture_result_comment": [
			{
				id: "throatSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.throat_swab_culture"
			}
		],
		"ltx|thrombophilia_comment": [
			{
				id: "thrombophilia",
				isLimitedAccess: false,
				titleMessageId: "form.thrombophilia"
			}
		],
		"ltx|thrombophilia_form": [
			{
				id: "thrombophilia",
				isLimitedAccess: false,
				titleMessageId: "form.thrombophilia"
			}
		],
		"ltx|toxoplasma_serology": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"ltx|toxoplasma_serology_igg": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"ltx|treponema_pallidum_org_screening_procedure": [
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			}
		],
		"ltx|tsh": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"ltx|urgency": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"ltx|urine_culture_result": [
			{
				id: "urineCulture",
				isLimitedAccess: false,
				titleMessageId: "form.urine_culture"
			}
		],
		"ltx|urine_culture_result_comment": [
			{
				id: "urineCulture",
				isLimitedAccess: false,
				titleMessageId: "form.urine_culture"
			}
		],
		"ltx|urology_result": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"ltx|vaccination_status": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_vaccination_status"
			}
		],
		"ltx|vaccine_type": [
			{
				id: "vaccinationStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_vaccination_status"
			}
		],
		"ltx|variceal_bleeding": [
			{
				id: "varicealBleeding",
				isLimitedAccess: false,
				titleMessageId: "form.varicealBleeding"
			}
		],
		"ltx|varicella_serology": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"ltx|varicella_serology_igg": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"ltx|veno-venous_bypass": [
			{
				id: "greenLight",
				isLimitedAccess: false,
				titleMessageId: "form.green_light"
			}
		],
		"ltx|waiting_list_start_date": [
			{
				id: "coordination",
				isLimitedAccess: false,
				titleMessageId: "form.coordination"
			}
		],
		"ltx|weight": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|1030791000000100": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|103306004": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"snomed|104305007": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"snomed|104321002": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			}
		],
		"snomed|104326007": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|105011006": [
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			}
		],
		"snomed|112143006": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|113075003": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			}
		],
		"snomed|117739006": [
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"snomed|128178001": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|165994006": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			},
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			},
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			},
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			},
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			},
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"snomed|166324000": [
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			}
		],
		"snomed|166329005": [
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			}
		],
		"snomed|169069000": [
			{
				id: "boneScan",
				isLimitedAccess: false,
				titleMessageId: "form.bone_scan"
			},
			{
				id: "ercp",
				isLimitedAccess: false,
				titleMessageId: "form.ercp"
			},
			{
				id: "liverBiopsy",
				isLimitedAccess: false,
				titleMessageId: "form.liver_biopsy"
			},
			{
				id: "mrcp",
				isLimitedAccess: false,
				titleMessageId: "form.mrcp"
			},
			{
				id: "oncology",
				isLimitedAccess: false,
				titleMessageId: "form.oncology"
			},
			{
				id: "otherConsultations",
				isLimitedAccess: false,
				titleMessageId: "form.other_consultations"
			},
			{
				id: "psychologicalAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.psychological_assessment"
			},
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			},
			{
				id: "asciticFluidCulture",
				isLimitedAccess: false,
				titleMessageId: "form.ascitic_fluid_culture"
			},
			{
				id: "nasalSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.nasal_swab_culture"
			},
			{
				id: "stoolCulture",
				isLimitedAccess: false,
				titleMessageId: "form.stool_culture"
			},
			{
				id: "throatSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.throat_swab_culture"
			},
			{
				id: "urineCulture",
				isLimitedAccess: false,
				titleMessageId: "form.urine_culture"
			},
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			},
			{
				id: "gastroscopia",
				isLimitedAccess: false,
				titleMessageId: "form.gastroscopia"
			}
		],
		"snomed|170865004": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"snomed|170945005": [
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			}
		],
		"snomed|171121004": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"snomed|19030005": [
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			}
		],
		"snomed|1951000175101": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			}
		],
		"snomed|20135006": [
			{
				id: "addictionAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.addiction_assessment"
			},
			{
				id: "boneScan",
				isLimitedAccess: false,
				titleMessageId: "form.bone_scan"
			},
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			},
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			},
			{
				id: "ercp",
				isLimitedAccess: false,
				titleMessageId: "form.ercp"
			},
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			},
			{
				id: "liverBiopsy",
				isLimitedAccess: false,
				titleMessageId: "form.liver_biopsy"
			},
			{
				id: "mrcp",
				isLimitedAccess: false,
				titleMessageId: "form.mrcp"
			},
			{
				id: "neurology",
				isLimitedAccess: false,
				titleMessageId: "form.neurology"
			},
			{
				id: "oncology",
				isLimitedAccess: false,
				titleMessageId: "form.oncology"
			},
			{
				id: "ophthalmologicExamination",
				isLimitedAccess: false,
				titleMessageId: "form.ophthalmologic_examination"
			},
			{
				id: "otherConsultations",
				isLimitedAccess: false,
				titleMessageId: "form.other_consultations"
			},
			{
				id: "psychiatricAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatric_assessment"
			},
			{
				id: "psychologicalAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.psychological_assessment"
			},
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			},
			{
				id: "colonoscopia",
				isLimitedAccess: false,
				titleMessageId: "form.colonoscopia"
			},
			{
				id: "asciticFluidCulture",
				isLimitedAccess: false,
				titleMessageId: "form.ascitic_fluid_culture"
			},
			{
				id: "nasalSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.nasal_swab_culture"
			},
			{
				id: "stoolCulture",
				isLimitedAccess: false,
				titleMessageId: "form.stool_culture"
			},
			{
				id: "throatSwabCulture",
				isLimitedAccess: false,
				titleMessageId: "form.throat_swab_culture"
			},
			{
				id: "urineCulture",
				isLimitedAccess: false,
				titleMessageId: "form.urine_culture"
			},
			{
				id: "abdominalCt",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ct"
			},
			{
				id: "abdominalMri",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_mri"
			},
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			},
			{
				id: "chestCt",
				isLimitedAccess: false,
				titleMessageId: "form.chest_ct.title"
			},
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			},
			{
				id: "craniumCt",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_ct"
			},
			{
				id: "craniumMr",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_mr"
			},
			{
				id: "gastroscopia",
				isLimitedAccess: false,
				titleMessageId: "form.gastroscopia"
			},
			{
				id: "lumbarSpineXRay",
				isLimitedAccess: false,
				titleMessageId: "form.lumbar_spine_x_ray"
			},
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			},
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			},
			{
				id: "hiv",
				isLimitedAccess: false,
				titleMessageId: "form.hiv"
			},
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			},
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			},
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			},
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			},
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			},
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hcv"
			},
			{
				id: "abdominalDopplerUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_doppler_ultrasound"
			},
			{
				id: "angiographyIndirectPortography",
				isLimitedAccess: false,
				titleMessageId: "form.angiography_indirect_portography"
			},
			{
				id: "ctAngiography",
				isLimitedAccess: false,
				titleMessageId: "form.ct_angiography"
			},
			{
				id: "anesthesiology",
				isLimitedAccess: false,
				titleMessageId: "form.anesthesiology"
			},
			{
				id: "ama",
				isLimitedAccess: false,
				titleMessageId: "form.ama"
			},
			{
				id: "ana",
				isLimitedAccess: false,
				titleMessageId: "form.ana"
			},
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			},
			{
				id: "cryoglobulin",
				isLimitedAccess: false,
				titleMessageId: "form.cryoglobulin"
			},
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			},
			{
				id: "lkm",
				isLimitedAccess: false,
				titleMessageId: "form.lkm"
			},
			{
				id: "pAnca",
				isLimitedAccess: false,
				titleMessageId: "form.panca"
			},
			{
				id: "sma",
				isLimitedAccess: false,
				titleMessageId: "form.sma"
			},
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			},
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			},
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"snomed|224238005": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|2425002": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"snomed|248326004": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|250644007": [
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			}
		],
		"snomed|26958001": [
			{
				id: "ama",
				isLimitedAccess: false,
				titleMessageId: "form.ama"
			},
			{
				id: "ana",
				isLimitedAccess: false,
				titleMessageId: "form.ana"
			},
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			},
			{
				id: "cryoglobulin",
				isLimitedAccess: false,
				titleMessageId: "form.cryoglobulin"
			},
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			},
			{
				id: "lkm",
				isLimitedAccess: false,
				titleMessageId: "form.lkm"
			},
			{
				id: "pAnca",
				isLimitedAccess: false,
				titleMessageId: "form.panca"
			},
			{
				id: "sma",
				isLimitedAccess: false,
				titleMessageId: "form.sma"
			},
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"snomed|30200007": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"snomed|305710003": [
			{
				id: "earNoseThroat",
				isLimitedAccess: false,
				titleMessageId: "form.ear_nose_throat"
			}
		],
		"snomed|305729009": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|312468003": [
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"snomed|312469006": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			}
		],
		"snomed|313587003": [
			{
				id: "varicellaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.varicella_serology"
			}
		],
		"snomed|313604004": [
			{
				id: "cmv",
				isLimitedAccess: false,
				titleMessageId: "form.cmv"
			}
		],
		"snomed|313954007": [
			{
				id: "ebvSerology",
				isLimitedAccess: false,
				titleMessageId: "form.ebv_serology"
			}
		],
		"snomed|315199001": [
			{
				id: "toxoplasmaSerology",
				isLimitedAccess: false,
				titleMessageId: "form.toxoplasma_serology"
			}
		],
		"snomed|33747003": [
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			}
		],
		"snomed|34043003": [
			{
				id: "addictionAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.addiction_assessment"
			},
			{
				id: "dentalScreening",
				isLimitedAccess: false,
				titleMessageId: "form.dental_screening"
			},
			{
				id: "neurology",
				isLimitedAccess: false,
				titleMessageId: "form.neurology"
			},
			{
				id: "psychiatricAssessment",
				isLimitedAccess: false,
				titleMessageId: "form.psychiatric_assessment"
			},
			{
				id: "anesthesiology",
				isLimitedAccess: false,
				titleMessageId: "form.anesthesiology"
			}
		],
		"snomed|34608000": [
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			}
		],
		"snomed|359986008": [
			{
				id: "scores",
				isLimitedAccess: false,
				titleMessageId: "form.scores"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			}
		],
		"snomed|363783003": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|363808001": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|365636006": [
			{
				id: "bloodGroup",
				isLimitedAccess: false,
				titleMessageId: "form.blood_group"
			}
		],
		"snomed|365809007": [
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			}
		],
		"snomed|371534008": [
			{
				id: "summaryReport",
				isLimitedAccess: false,
				titleMessageId: "form.summary_report"
			}
		],
		"snomed|395043005": [
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			}
		],
		"snomed|396550006": [
			{
				id: "ama",
				isLimitedAccess: false,
				titleMessageId: "form.ama"
			},
			{
				id: "ana",
				isLimitedAccess: false,
				titleMessageId: "form.ana"
			},
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			},
			{
				id: "cryoglobulin",
				isLimitedAccess: false,
				titleMessageId: "form.cryoglobulin"
			},
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			},
			{
				id: "lkm",
				isLimitedAccess: false,
				titleMessageId: "form.lkm"
			},
			{
				id: "pAnca",
				isLimitedAccess: false,
				titleMessageId: "form.panca"
			},
			{
				id: "sma",
				isLimitedAccess: false,
				titleMessageId: "form.sma"
			},
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			},
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			},
			{
				id: "bilirubinTotal",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_total"
			},
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			},
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			},
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			},
			{
				id: "gpt",
				isLimitedAccess: false,
				titleMessageId: "form.gpt"
			},
			{
				id: "haemoglobin",
				isLimitedAccess: false,
				titleMessageId: "form.haemoglobin"
			},
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			},
			{
				id: "inr",
				isLimitedAccess: false,
				titleMessageId: "form.inr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "ldh",
				isLimitedAccess: false,
				titleMessageId: "form.ldh"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			},
			{
				id: "prealbumin",
				isLimitedAccess: false,
				titleMessageId: "form.prealbumin"
			},
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			},
			{
				id: "serumGlucose",
				isLimitedAccess: false,
				titleMessageId: "form.serum_glucose"
			},
			{
				id: "t3",
				isLimitedAccess: false,
				titleMessageId: "form.t3"
			},
			{
				id: "t4",
				isLimitedAccess: false,
				titleMessageId: "form.t4"
			},
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"snomed|39748002": [
			{
				id: "bilirubinDirect",
				isLimitedAccess: false,
				titleMessageId: "form.bilirubin_direct"
			}
		],
		"snomed|399208008": [
			{
				id: "chestXray",
				isLimitedAccess: false,
				titleMessageId: "form.chest_xray"
			},
			{
				id: "lumbarSpineXRay",
				isLimitedAccess: false,
				titleMessageId: "form.lumbar_spine_x_ray"
			}
		],
		"snomed|408218006": [
			{
				id: "hsv1Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv1_serology"
			},
			{
				id: "hsv2Serology",
				isLimitedAccess: false,
				titleMessageId: "form.hsv2_serology"
			}
		],
		"snomed|410006001": [
			{
				id: "urology",
				isLimitedAccess: false,
				titleMessageId: "form.urology"
			}
		],
		"snomed|43396009": [
			{
				id: "hgbA1C",
				isLimitedAccess: false,
				titleMessageId: "form.hgba1v"
			}
		],
		"snomed|440614003": [
			{
				id: "gynecology",
				isLimitedAccess: false,
				titleMessageId: "form.gynecology"
			}
		],
		"snomed|44277000": [
			{
				id: "creatinine",
				isLimitedAccess: false,
				titleMessageId: "form.creatinine"
			},
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			},
			{
				id: "karbamid",
				isLimitedAccess: false,
				titleMessageId: "form.karbamid"
			},
			{
				id: "natrium",
				isLimitedAccess: false,
				titleMessageId: "form.natrium"
			},
			{
				id: "potassium",
				isLimitedAccess: false,
				titleMessageId: "form.potassium"
			}
		],
		"snomed|45036003": [
			{
				id: "abdominalCt",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ct"
			},
			{
				id: "abdominalMri",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_mri"
			},
			{
				id: "abdominalUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_ultrasound"
			},
			{
				id: "craniumCt",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_ct"
			},
			{
				id: "craniumMr",
				isLimitedAccess: false,
				titleMessageId: "form.cranium_mr"
			},
			{
				id: "abdominalDopplerUltrasound",
				isLimitedAccess: false,
				titleMessageId: "form.abdominal_doppler_ultrasound"
			},
			{
				id: "angiographyIndirectPortography",
				isLimitedAccess: false,
				titleMessageId: "form.angiography_indirect_portography"
			},
			{
				id: "ctAngiography",
				isLimitedAccess: false,
				titleMessageId: "form.ct_angiography"
			}
		],
		"snomed|45896001": [
			{
				id: "got",
				isLimitedAccess: false,
				titleMessageId: "form.got"
			}
		],
		"snomed|47758006": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"snomed|50373000": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|50506008": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"snomed|50684000": [
			{
				id: "pseudocholinesterase",
				isLimitedAccess: false,
				titleMessageId: "form.pseudocholinesterase"
			}
		],
		"snomed|54555005": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"snomed|55235003": [
			{
				id: "crp",
				isLimitedAccess: false,
				titleMessageId: "form.crp"
			}
		],
		"snomed|60621009": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"snomed|61167004": [
			{
				id: "tsh",
				isLimitedAccess: false,
				titleMessageId: "form.tsh"
			}
		],
		"snomed|61928009": [
			{
				id: "plateletCount",
				isLimitedAccess: false,
				titleMessageId: "form.platelet_count"
			}
		],
		"snomed|62889000": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"snomed|62944002": [
			{
				id: "hcv",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hcv"
			}
		],
		"snomed|63476009": [
			{
				id: "psa",
				isLimitedAccess: false,
				titleMessageId: "form.psa"
			}
		],
		"snomed|65911000": [
			{
				id: "hbvStatus",
				isLimitedAccess: false,
				titleMessageId: "form.ltx_hbv_status"
			}
		],
		"snomed|69480007": [
			{
				id: "antiCardiolipinAt",
				isLimitedAccess: false,
				titleMessageId: "form.anti_cardiolipin_at"
			},
			{
				id: "immunElfo",
				isLimitedAccess: false,
				titleMessageId: "form.immun_elfo"
			},
			{
				id: "ggt",
				isLimitedAccess: false,
				titleMessageId: "form.ggt"
			}
		],
		"snomed|72904005": [
			{
				id: "treponemaPallidum",
				isLimitedAccess: false,
				titleMessageId: "form.treponema_pallidum"
			}
		],
		"snomed|767002": [
			{
				id: "fvs",
				isLimitedAccess: false,
				titleMessageId: "form.fvs"
			}
		],
		"snomed|77465005": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"snomed|80274001": [
			{
				id: "gfr",
				isLimitedAccess: false,
				titleMessageId: "form.gfr"
			}
		],
		"snomed|88810008": [
			{
				id: "alkalinePhosphatase",
				isLimitedAccess: false,
				titleMessageId: "form.alkaline_phosphatase"
			}
		],
		"snomed|89780004": [
			{
				id: "patientCondition",
				isLimitedAccess: true,
				titleMessageId: "form.patient_condition"
			}
		],
		"srtr|can_hgt_cm": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		],
		"srtr|can_most_recent_wgt_kg7": [
			{
				id: "anthropometrics",
				isLimitedAccess: false,
				titleMessageId: "form.anthropometrics"
			}
		]
	}
};
